(function(api) {
	api.SaldaZaNovi = SaldaZaNovi;
	api.SaldaZaUzDokument = SaldaZaUzDokument;
	api.GetIopSFields = GetIopSFields;	
	api.IopSObrisi = IopSObrisi;
	api.IopObrisi = IopObrisi;
	api.GetIopNAFields = GetIopNAFields;
	api.IopNAObrisi = IopNAObrisi;
	api.RuGrupaSifra = RuGrupaSifra;
	api.PregledIsplaceno = PregledIsplaceno;
	api.PregledIsplacenoDob = PregledIsplacenoDob;
	api.GotovoObrisi = GotovoObrisi;
	api.GotovoSkupniUnosIspravak = GotovoSkupniUnosIspravak;
	api.GetRUgovorSFields = GetRUgovorSFields;
	api.GetRiznicaSFields = GetRiznicaSFields;
	api.RUgovorSListaPremaShemiURuGrupa = RUgovorSListaPremaShemiURuGrupa;
	api.GetRUgovorParFields = GetRUgovorParFields;
	api.GetIopFields = GetIopFields;
	api.GetPovijestSFields = GetPovijestSFields;
	api.GetRUgovorZadnji = GetRUgovorZadnji;
	api.RUgovorSObrisi = RUgovorSObrisi;
	api.RUgovorSSkupnoObrisi = RUgovorSSkupnoObrisi;
	api.RUgovorSZakljucaj = RUgovorSZakljucaj;
	api.RUgovorObrisi = RUgovorObrisi;
	api.RUgovorGetLabelCaption = RUgovorGetLabelCaption;
	api.RUgovorSGetLabelCaption = RUgovorSGetLabelCaption;	
	api.RUgovorKreirajMjestoTroska = RUgovorKreirajMjestoTroska;
	api.PrikaziRuShemuKnjizenja = PrikaziRuShemuKnjizenja;
	api.ProtuZaSaldaFields = ProtuZaSaldaFields;
	api.OpomeneZaSaldaFields = OpomeneZaSaldaFields;	
	api.RnUplataZaSaldaFields = RnUplataZaSaldaFields;
	api.GetSaldaTrFields = GetSaldaTrFields;
	api.GetSTrosakFields = GetSTrosakFields;
	api.PdvKnjigaNazivPartneraCaption = PdvKnjigaNazivPartneraCaption;
	api.PdvKnjigaSZaSaldaFields = PdvKnjigaSZaSaldaFields;
	api.PdvKnjigaSPostoNeMozeCaption = PdvKnjigaSPostoNeMozeCaption;
	api.PdvKnjigaSSetAfterPolje = PdvKnjigaSSetAfterPolje;
	api.PdvKnjigaOZaPdvFields = PdvKnjigaOZaPdvFields;
	api.PdvObrMogucaObrada = PdvObrMogucaObrada;
	api.PdvObrObradaPitanja = PdvObrObradaPitanja;
	api.PdvObrObrisi = PdvObrObrisi;
	api.PdvObrAzuriraj = PdvObrAzuriraj;
	api.PdvStMoguceBrisanje = PdvStMoguceBrisanje;
	api.PdvStBrisanjePitanja = PdvStBrisanjePitanja;
	api.PdvStObrisi = PdvStObrisi;
	api.SaldaMoguceBrisanje = SaldaMoguceBrisanje;	
	api.SaldaMogucaPromjenaStatusa = SaldaMogucaPromjenaStatusa;	
	api.SaldaObrisi = SaldaObrisi;
	api.PdvKnjigaZaDokument = PdvKnjigaZaDokument;
	api.PdvVrstaById = PdvVrstaById;
	api.PdvKnjigaObrisi = PdvKnjigaObrisi;
	api.PdvKnjigaAzurirajRedneBrojeveDaSlijedeDatumKnjige = PdvKnjigaAzurirajRedneBrojeveDaSlijedeDatumKnjige;
	api.PdvKnjigaSZaKnjigaFields = PdvKnjigaSZaKnjigaFields;	
	api.KnjigaMoguceBrisanje = KnjigaMoguceBrisanje;	
	api.KnjigaObrisi = KnjigaObrisi;
	api.ProtuPredlozakMoguceBrisanje = ProtuPredlozakMoguceBrisanje;
	api.ProtuPredlozakObrisi = ProtuPredlozakObrisi;
	api.ProtuMoguceKnjizenjeSaldaZatvaraRUVanbil = ProtuMoguceKnjizenjeSaldaZatvaraRUVanbil;
	api.ProtuMoguceBrisanjeRUVanbil = ProtuMoguceBrisanjeRUVanbil;
	api.ProtuObrisiRuVanbil = ProtuObrisiRuVanbil;
	api.ProtuObrisiKnjiziRuVanbil = ProtuObrisiKnjiziRuVanbil;
	api.ProtuKnjiziRuVanbil = ProtuKnjiziRuVanbil;
	api.ProvjeriBrisanjeProtuNerasknjizen = ProvjeriBrisanjeProtuNerasknjizen;
	api.ProtuMoguceBrisanje = ProtuMoguceBrisanje;
	api.ProtuObrisi = ProtuObrisi;
	api.GetNextGkBrojDokumenta = GetNextGkBrojDokumenta;
	api.GetNextGkBrojStavke = GetNextGkBrojStavke;
	api.GetKontoKD = GetKontoKD;
	api.SaldoDokumentaKnjiga = SaldoDokumentaKnjiga;
	api.KnjigaIzrSaldo = KnjigaIzrSaldo;
	api.PdvKnjigaDuploCaption = PdvKnjigaDuploCaption;
	api.PdvKnjigaPartnerCaption = PdvKnjigaPartnerCaption;
	api.PdvKnjigaPdvIraCaption = PdvKnjigaPdvIraCaption;
	api.PdvKnjigaDatumPdvEnabled = PdvKnjigaDatumPdvEnabled;
	api.PdvKnjigaSetAfterPolje = PdvKnjigaSetAfterPolje;
	api.SaldaById = SaldaById;
	api.GetNextPdvKnjigaRedni = GetNextPdvKnjigaRedni;
	api.PartnerSkracenoPlusOIB = PartnerSkracenoPlusOIB;
	api.GetKnjigaIdZaPrvuProtu = GetKnjigaIdZaPrvuProtu;
	api.GetPredlozakZaPartnera = GetPredlozakZaPartnera;
	api.PredloziSaldaZaKonto = PredloziSaldaZaKonto;
	api.SaldoDokumenta = SaldoDokumenta;
	api.GetNextBrojDokumenta = GetNextBrojDokumenta;
	api.GetNextBrojStavke = GetNextBrojStavke;
	api.KnjigaById = KnjigaById;
	api.GetMaxKonto = GetMaxKonto;
	api.DokumById = DokumById;
	api.KontoById = KontoById;
	api.KontoNoviValidatePostoji = KontoNoviValidatePostoji; 
	api.GetBrojDokumenta = GetBrojDokumenta;
	api.PredlozakSById = PredlozakSById;
	api.ObrisiPredlozakZaDokum = ObrisiPredlozakZaDokum;
	api.GetRuKorUgFields = GetRuKorUgFields;
	api.GetRuRacunFields = GetRuRacunFields;
	api.GetRuRacunSFields = GetRuRacunSFields;	
	api.GetRuZahtjevFields = GetRuZahtjevFields;
	api.GetRuZahtjevSFields = GetRuZahtjevSFields;
	api.RUZahtjevSLista = RUZahtjevSLista;
	api.RuRacunSObrisi = RuRacunSObrisi;
	api.RuRacunObrisi = RuRacunObrisi;
	api.RuZahtjevSObrisi = RuZahtjevSObrisi;
	api.RuZahtjevObrisi = RuZahtjevObrisi;
	api.RuZahtjevObrisiSkupno = RuZahtjevObrisiSkupno;
	api.PredloziIznosPredujma = PredloziIznosPredujma;
	api.RuRacunSById = RuRacunSById;
	api.RUgovorSById = RUgovorSById;
	api.RUgovorSZNSById = RUgovorSZNSById;
	api.RUgovorZNS = RUgovorZNS;
	api.RUZStatusById = RUZStatusById;
	api.RUgovorSZaRuRacunS = RUgovorSZaRuRacunS;
	api.RuRacunById = RuRacunById;
	api.RuKorUgObrisi = RuKorUgObrisi;
	api.PostojiVanbilancnoZaduzenjeRU = PostojiVanbilancnoZaduzenjeRU;
	api.KnjiziRuZaduzenjeVanbil = KnjiziRuZaduzenjeVanbil;
	api.StornoRuZaduzenjeVanbil = StornoRuZaduzenjeVanbil;
	api.ProvjeriDatumeRn = ProvjeriDatumeRn;
	api.RUgovorSaldoPo = RUgovorSaldoPo;
	api.ProvjeriPartnerObaveznoIPostoji = ProvjeriPartnerObaveznoIPostoji;
	api.DajSaldaZaStariPK = DajSaldaZaStariPK;
	api.PredlozakImaVezuInteract = PredlozakImaVezuInteract;
	api.PredlozakSImaVezuInteract = PredlozakSImaVezuInteract;
	api.PredlozakObrisi = PredlozakObrisi;
	api.PredlozakSObrisi = PredlozakSObrisi; 
	api.GetRUgovorVezaFields = GetRUgovorVezaFields;
	api.RUgovorVezaObrisi = RUgovorVezaObrisi;
	api.PVTroskaObrisi = PVTroskaObrisi;	
	api.KnjigaSetAfterPolje = KnjigaSetAfterPolje;
	api.KnjigaSetAfterMTroska = KnjigaSetAfterMTroska;
	api.KnjigaSetAfterOrgan = KnjigaSetAfterOrgan;
	api.KopiranjeSetAfterPolje = KopiranjeSetAfterPolje;
	api.KopiranjeBeforePost = KopiranjeBeforePost;
	api.DajNazivZaKlasuKonta = DajNazivZaKlasuKonta;
	api.DajKlasu = DajKlasu;
	api.KontoObrisi = KontoObrisi;
	api.GetPNabaveSFields = GetPNabaveSFields;	
	api.GetPNabaveFields = GetPNabaveFields;
	api.PNabaveById = PNabaveById;
	api.PNabaveSById = PNabaveSById;		
	api.PNabaveSNazivById = PNabaveSNazivById;
	api.PNabaveSRenumerirajStavke = PNabaveSRenumerirajStavke;
	api.PNabaveSProvjeriOvlastenjaNaOjMt = PNabaveSProvjeriOvlastenjaNaOjMt;
	api.GetRaspored = GetRaspored;
	api.ProracunSetAfterPolje = ProracunSetAfterPolje;
	api.ProracunPlaniranoValidateIspravnoPremaTecajuNaDan = ProracunPlaniranoValidateIspravnoPremaTecajuNaDan;
	api.ProracunPozicijaValidateDozvoljena = ProracunPozicijaValidateDozvoljena;
	api.ProracunPitanjePrijeGeneriranjaAzuriranjaStavkiPlana = ProracunPitanjePrijeGeneriranjaAzuriranjaStavkiPlana;
	api.ProracunUpisiAzurirajStavkaPlanaZaPlan = ProracunUpisiAzurirajStavkaPlanaZaPlan;
	api.ProracunGenerirajStavkePremaKontimaUGK = ProracunGenerirajStavkePremaKontimaUGK;
	api.ProracunOtvoriProracunSa0 = ProracunOtvoriProracunSa0;
	api.ProracunPitanjePrijeBrisanjaStavkiPlana = ProracunPitanjePrijeBrisanjaStavkiPlana;
	api.ProracunObrisiStavkePlana = ProracunObrisiStavkePlana;
	api.OvlastenjeDeaktiviraj = OvlastenjeDeaktiviraj;
	api.ImportPlanProrXls = ImportPlanProrXls;
	api.GetPlanProrSume = GetPlanProrSume;
	api.GetProrUtrSFields = GetProrUtrSFields;
	api.ProrUtrObrisi = ProrUtrObrisi;
	api.ProrUtrSObrisi = ProrUtrSObrisi;
	api.ProrUtrZakljucavanje = ProrUtrZakljucavanje;
	api.ProrUtrPromjenaStatusa = ProrUtrPromjenaStatusa;	
	api.ProrUtrSUpisiIzGrida = ProrUtrSUpisiIzGrida;
	api.ProrUtrById = ProrUtrById;
	api.ProrUtrSProvjeriIznos = ProrUtrSProvjeriIznos;
	api.ProrUtrPostojiVezaGS = ProrUtrPostojiVezaGS;	
	api.ProrUtrUpisaniIznosiOdobrenja = ProrUtrUpisaniIznosiOdobrenja;	
	api.GetIznosiIzvora = GetIznosiIzvora;
	api.PozGrupaById = PozGrupaById;
	api.RiznicaById = RiznicaById;
	api.RiznicaSById = RiznicaSById;
	api.RUgovorZaRiznica = RUgovorZaRiznica;
	api.RUgovorIzDokument = RUgovorIzDokument;
	api.RizDokById = RizDokById;
	api.RizDokSapById = RizDokSapById;

	api.ProracunIzmijeniPlaniranoZaGodinu = ProracunIzmijeniPlaniranoZaGodinu;
	api.ProracunGetPorukaZaBrisanje = ProracunGetPorukaZaBrisanje;
	api.ProracunExportXLSZaPivotUPozadini = ProracunExportXLSZaPivotUPozadini;
	api.ProrKonSetAfterPolje = ProrKonSetAfterPolje;
	api.PregledUgovorenoZaPNabaveS = PregledUgovorenoZaPNabaveS;	
	api.PozicijaById = PozicijaById;
    api.IzvoriById = IzvoriById;
    api.IzvoriGrupaIzvjestajById = IzvoriGrupaIzvjestajById;
    api.IzvoriIzvoriPrihodaById = IzvoriIzvoriPrihodaById;
    api.RUgovorById = RUgovorById;
    api.ProvjeriAktivanZR = ProvjeriAktivanZR;
    
    
    api.PlanProrUpdatePozicije = PlanProrUpdatePozicije;
    api.PlanProrKopiraj = PlanProrKopiraj;
    api.PlanProrPitanjaPrijeUpisa = PlanProrPitanjaPrijeUpisa;
    api.ProrPraviloPlanJeZakljucan = ProrPraviloPlanJeZakljucan;
    api.ProrPraviloProracunJeZakljucan = ProrPraviloProracunJeZakljucan;
    api.ProrPraviloZakljucajOtkljucajPlan = ProrPraviloZakljucajOtkljucajPlan;
    api.ProrPraviloZakljucajOtkljucajProracun = ProrPraviloZakljucajOtkljucajProracun;
    api.PlanProrPorukaZaProvjeruLimitaPlana = PlanProrPorukaZaProvjeruLimitaPlana;
    api.ProrPraviloDajPitanjeZaZakljucavanjeProracuna = ProrPraviloDajPitanjeZaZakljucavanjeProracuna;
    api.PlanProrGetNezakljucaneStavkePlana = PlanProrGetNezakljucaneStavkePlana;
    api.ProracunProvjeraLimita = ProracunProvjeraLimita;
     
	api.OtpremaObrisi = OtpremaObrisi;    
	api.OtpremaSetAfterPolje = OtpremaSetAfterPolje;
	api.GetOtpremaSFields = GetOtpremaSFields;
	api.OtpremaSById = OtpremaSById;	
	api.OtpremaSObrisi = OtpremaSObrisi;
	api.OtpremaSZakljucaj = OtpremaSZakljucaj;
	api.OtpGenerirajSetAfterBtn = OtpGenerirajSetAfterBtn;	
	api.OtpGenerirajUPozadiniSetAfterBtn = OtpGenerirajUPozadiniSetAfterBtn;
	api.OtpremaSSetAfterPolje = OtpremaSSetAfterPolje;

	api.RjesenjeObrisi = RjesenjeObrisi;	
	api.GetRjRedakFields = GetRjRedakFields;
	api.RjRedakObrisi = RjRedakObrisi;
	api.GetNaNGrupe = GetNaNGrupe;	
	api.OtpremaPromStatus = OtpremaPromStatus;	
	api.OtpremaPromStatusBezDizanjaErrora = OtpremaPromStatusBezDizanjaErrora;	

	api.ProrUtrPrenesiZahtjevUGs = ProrUtrPrenesiZahtjevUGs;
	api.ProrUtrPrenesiZahtjevUGsBezDizanjaErrora = ProrUtrPrenesiZahtjevUGsBezDizanjaErrora;	
	
	api.PNabaveSPreracunajUgovoreno = PNabaveSPreracunajUgovoreno;
	api.DokumentiPNabaveS = DokumentiPNabaveS;
	api.SalOtvoreneZaSalda = SalOtvoreneZaSalda;
	api.GetSalOtvoreneSaldo = GetSalOtvoreneSaldo;
	api.GetSalOtvoreneFields = GetSalOtvoreneFields;
		
	api.RuZahtjevPromStatus = RuZahtjevPromStatus;	
	api.RuZahtjevPromStatusSkupno = RuZahtjevPromStatusSkupno;	
	
    api.KnjigaGenPrihodZaStavku = KnjigaGenPrihodZaStavku;
    
	api.IopImportXlsUPozadini = IopImportXlsUPozadini;
	api.PNabaveSImportXlsUPozadini = PNabaveSImportXlsUPozadini;
    api.IzboriDajOpisZaSlijediUPr = IzboriDajOpisZaSlijediUPr;
    
    api.DajObavKnjModel = DajObavKnjModel;
    api.DajObavKnjZaduzenjeZa = DajObavKnjZaduzenjeZa;
    api.ObavKnjPlusMinusCaption = ObavKnjPlusMinusCaption;
    api.ObavKnjPorezIznosCaption = ObavKnjPorezIznosCaption;
    api.ObavKnjPorezEnabled = ObavKnjPorezEnabled;
    api.ObavKnjSetAfterPolje = ObavKnjSetAfterPolje;
	
	api.GetNovaStavka = GetNovaStavka;
	api.PostojiStavkaZaPNabaveIVerziju = PostojiStavkaZaPNabaveIVerziju;
	api.MTroskaKarticaInfo = MTroskaKarticaInfo;
    api.OdrediKnjizenjePremaRUgovor = OdrediKnjizenjePremaRUgovor;
    api.OdrediKnjizenjePremaRiznica = OdrediKnjizenjePremaRiznica;
	api.RUgovorZaOdabirParam = RUgovorZaOdabirParam;
	api.RiznicaZaOdabirParam = RiznicaZaOdabirParam;
     
	api.PredloziAktivnostZaProjekt = PredloziAktivnostZaProjekt;
	api.PredloziIzvoreZaProjekt = PredloziIzvoreZaProjekt;
	
	api.STrosakSetAfterPolje = STrosakSetAfterPolje;
	api.GetSifrePlanova = GetSifrePlanova;
	 
	api.KnjigaRuPostoji = KnjigaRuPostoji;
	api.KnjigaRuVratiRugovor = KnjigaRuVratiRugovor; 
	api.GenerirajKnjigaRU = GenerirajKnjigaRU;
	api.KnjigaRuMoguceBrisanje = KnjigaRuMoguceBrisanje;
	api.KnjigaRuObrisi = KnjigaRuObrisi;
	api.KnjigaRuGenerirajIznose = KnjigaRuGenerirajIznose;
	api.KnjigaRuSalda = KnjigaRuSalda;		
	api.GetKnjigaRuFields = GetKnjigaRuFields;	
	api.KnjigaRuZatvori = KnjigaRuZatvori;
	api.KnjigaRuPredloziNovi = KnjigaRuPredloziNovi;
	api.GetHRValutaOznakaNaDan = GetHRValutaOznakaNaDan;
	api.GetIopValuta = GetIopValuta;
	
	api.KnjigaRasObrisi = KnjigaRasObrisi;
	api.GetUkupnoZaPosto = GetUkupnoZaPosto;
	api.KnjigaRasNemaKoloneUNacinu = KnjigaRasNemaKoloneUNacinu;
		 
	api.IzvodShemaPomakniGore = IzvodShemaPomakniGore;
	api.IzvodShemaPomakniDolje = IzvodShemaPomakniDolje;
	api.IzvodShemaGetPrioritetZadnjiCaption = IzvodShemaGetPrioritetZadnjiCaption;	
	api.IzvodShemaGetPrioritetCaption = IzvodShemaGetPrioritetCaption;	
	api.IzvodShemaGetPrioritetPostojiCaption = IzvodShemaGetPrioritetPostojiCaption;	
	api.GetIzvodSFields = GetIzvodSFields;	
	api.GetIzvodSBrisanjePitanje = GetIzvodSBrisanjePitanje;
	api.GetIzvodSBrisanjePoruka = GetIzvodSBrisanjePoruka;
	api.IzvodSObrisi = IzvodSObrisi;
	api.GetKnjizenjeIzvodaCaption = GetKnjizenjeIzvodaCaption;
	api.GetIzvodProknjizitiPitanje = GetIzvodProknjizitiPitanje;
	api.GetIzvodBrisanjePitanje = GetIzvodBrisanjePitanje;
	api.IzvodObrisi = IzvodObrisi;	
	api.RUGrupaById = RUGrupaById;
	api.GetRUgovorTemplate = GetRUgovorTemplate;
	api.PartnerImaOtvorenihStavaka = PartnerImaOtvorenihStavaka;	
	api.IzvodSSetAfterBrojRacuna = IzvodSSetAfterBrojRacuna;
	api.IzvodSKodKnjizenjaIzvodaSeUZatvoriRnUpisujeBrojUfe = IzvodSKodKnjizenjaIzvodaSeUZatvoriRnUpisujeBrojUfe;
	api.IzvodSKodZatvaranjaProvjeriOJUBrojuRacuna = IzvodSKodZatvaranjaProvjeriOJUBrojuRacuna;
	api.IzvodValidateMoguceKnjizenjeOdabranih = IzvodValidateMoguceKnjizenjeOdabranih;
	api.IzvodProknjizi = IzvodProknjizi;
	api.IzvodProknjiziPost = IzvodProknjiziPost;	
	api.IzvodProknjiziUPozadini = IzvodProknjiziUPozadini;	
	api.GetIzvodSaldoDugujePotrazuje = GetIzvodSaldoDugujePotrazuje;
	api.ProcitajIzvadak = ProcitajIzvadak;	
	api.PreuzmiIzvodDokumentPostoji = PreuzmiIzvodDokumentPostoji;
	api.PreuzmiIzvodDokumentVecProknjizen = PreuzmiIzvodDokumentVecProknjizen;		
	api.PreuzmiIzvodPreuzmiIzvod = PreuzmiIzvodPreuzmiIzvod;
	api.GetProracunSFields = GetProracunSFields;
	api.GetUrediRedoslijedGkBrojStavke = GetUrediRedoslijedGkBrojStavke;
	api.UrediRedoslijedGkBrojStavke = UrediRedoslijedGkBrojStavke;
	api.GetKnjigaPonistiVezuSaSK = GetKnjigaPonistiVezuSaSK;
	api.KnjigaPonistiVezuSaSK = KnjigaPonistiVezuSaSK;
	api.KnjigaSaldoPartneraZaOvajDokument = KnjigaSaldoPartneraZaOvajDokument;
	api.KnjigaGetPartnerZaOvajDokument = KnjigaGetPartnerZaOvajDokument;
	api.KnjigaZakljucajDokument = KnjigaZakljucajDokument;
	api.KnjigaOtkljucajDokument = KnjigaOtkljucajDokument;
	api.KnjigaGetDokumentZakljucanCaption = KnjigaGetDokumentZakljucanCaption;
	api.GenPrometaSetRequiredAfterKontoPrometa = GenPrometaSetRequiredAfterKontoPrometa;
	api.GetRiznicaLabelCaption = GetRiznicaLabelCaption;	
	api.PredloziKontoDo = PredloziKontoDo;
	api.KnjigaIzrSaldoFilter = KnjigaIzrSaldoFilter;
	api.SaldaSetAfterPolje = SaldaSetAfterPolje;	
	api.SaldaSetAfterMTroska = SaldaSetAfterMTroska;
	api.SaldaSetAfterOrgan = SaldaSetAfterOrgan;
	api.IzvodSPrimjeniPravilo = IzvodSPrimjeniPravilo;
	api.IzvodSSetAfterPolje = IzvodSSetAfterPolje;	
	api.IzvodSPredloziKnjizenje = IzvodSPredloziKnjizenje;	
	api.ProrUtrProvjeriDupliMjesecniPlan = ProrUtrProvjeriDupliMjesecniPlan;
	api.ProracunById = ProracunById;				 		
	api.IzvodSPoveziSViseFaktura = IzvodSPoveziSViseFaktura;	
	api.SalOtvoreneStaviUListuZatvorenihRacuna = SalOtvoreneStaviUListuZatvorenihRacuna;					 						 		
	api.SalOtvoreneZatvaranjeRacunaUplatomIliTemeljnicom = SalOtvoreneZatvaranjeRacunaUplatomIliTemeljnicom;				 		
	api.ZatvoriTemGetNextBroj = ZatvoriTemGetNextBroj;
	api.ZatvoriTemValidateBrojDokumenta = ZatvoriTemValidateBrojDokumenta;	
	api.SalOtvoreneOvrhe = SalOtvoreneOvrhe;	
	api.KnjigaPromBrDokGetNextBroj = KnjigaPromBrDokGetNextBroj;	
	api.SaldaPromBrDokGetNextBroj = SaldaPromBrDokGetNextBroj;		
	api.AzurUtrosenoOtpustenoFakturiranoZaRUgovor = AzurUtrosenoOtpustenoFakturiranoZaRUgovor;
	api.DokumentDatumDospjecaNeradniDan = DokumentDatumDospjecaNeradniDan;
	api.KnjiziTecRazlikeSetAfterPolje = KnjiziTecRazlikeSetAfterPolje;
	api.KnjiziTecRazlikeNextBrojDok = KnjiziTecRazlikeNextBrojDok;	
	api.KnjiziTecRazlikeDBToGsVars = KnjiziTecRazlikeDBToGsVars;
	api.PNabaveSKontrolePlanPror = PNabaveSKontrolePlanPror;		
	api.GenProtuSetAfterPolje = GenProtuSetAfterPolje;	
	api.GenProtuGetPitanja = GenProtuGetPitanja;	
	api.SaldaTrSetAfterPolje = SaldaTrSetAfterPolje;
	api.GenKnjigaRasSetAfterPolje = GenKnjigaRasSetAfterPolje;
	api.GenKnjigaRasValidate = GenKnjigaRasValidate;
	api.GenProtuDBToGsVars = GenProtuDBToGsVars;
	api.GetOpzStatSFields = GetOpzStatSFields;
	api.GetOpzStatPitanjaZaBrisanje = GetOpzStatPitanjaZaBrisanje;
	api.GetPitanjaZaObrisiVezuPremaSKIzStavaka = GetPitanjaZaObrisiVezuPremaSKIzStavaka;
	api.GetOpzStatSPitanjaZaBrisanje = GetOpzStatSPitanjaZaBrisanje;
	api.OpzStatAzuriraj = OpzStatAzuriraj;
	api.OpzStatSObrisi = OpzStatSObrisi;
	api.ObrisiSveStavkeZaKonto = ObrisiSveStavkeZaKonto; 		
	api.GetPitanjaZaBrisanjeSvihStavakaZaKonto = GetPitanjaZaBrisanjeSvihStavakaZaKonto;
	api.GetPitanjaZaFormiranjeOpzStat = GetPitanjaZaFormiranjeOpzStat;
	api.OpzStatSSetAfterPartner = OpzStatSSetAfterPartner;
	api.KontoNadredjenaKontaPostoje = KontoNadredjenaKontaPostoje;
	api.GetVanbilancnoFields = GetVanbilancnoFields;
	api.KnjigaBrisanjeViseStavaka = KnjigaBrisanjeViseStavaka;
	api.NaplacenGsObrisi = NaplacenGsObrisi;
	api.NaplacenGsObrisiList = NaplacenGsObrisiList;
	api.NaplacenGsGeneriraj = NaplacenGsGeneriraj;
	api.NaplacenGsIzvjestavanje = NaplacenGsIzvjestavanje;
	api.NaplacenGsOznaciDaJeRucnoIzvijesteno = NaplacenGsOznaciDaJeRucnoIzvijesteno;
	api.SaldaImportXlsUPozadini = SaldaImportXlsUPozadini;
	api.ProvjeriProtukontoTrebaBitiZadan = ProvjeriProtukontoTrebaBitiZadan;
	api.PartnerKorSrIzOibIzBrojRacuna = PartnerKorSrIzOibIzBrojRacuna;
	api.KnjigaImportXlsUPozadini = KnjigaImportXlsUPozadini;
	api.IRazno2AfterVrstaDok = IRazno2AfterVrstaDok;
	
	
	function GetSifrePlanova(sifraPlana){
		return $.dsDirectCall({
			method: "GetSifrePlanova",
			params: [sifraPlana]
	    });	
	}


	function ProracunIzmijeniPlaniranoZaGodinu(proracun, planirano, polje){
		return $.dsDirectCall({
			method: "ProracunIzmijeniPlaniranoZaGodinu",
			params: [proracun, planirano, polje]
	    });
	}	

	function ProracunGetPorukaZaBrisanje(proracun){
		return $.dsDirectCall({
			method: "ProracunGetPorukaZaBrisanje",
			params: [proracun]
	    });	
	}

	function ProracunExportXLSZaPivotUPozadini(planprorid){
		return $.dsDirectCall({
			method: "ProracunExportXLSZaPivotUPozadini",
			params: [planprorid]
	    });	
	}
	
	function ProrUtrSProvjeriIznos(prorutrs){
		return $.dsDirectCall({
			method: "ProrUtrSProvjeriIznos",
			params: [prorutrs]
	    });
	}		

	function GetIznosiIzvora(prorutr, izvori){
		return $.dsDirectCall({
			method: "GetIznosiIzvora",
			params: [prorutr, izvori]
	    });
	}

	function ProrUtrById(prorUtr){
		return $.dsDirectCall({
			method: "ProrUtrById",
			params: [prorUtr]
	    });
	}

	function PozGrupaById(pozGrupa, vrsta){
		return $.dsDirectCall({
			method: "PozGrupaById",
			params: [pozGrupa, vrsta]
	    });
	}

	function ProrUtrSUpisiIzGrida(prorUtr, proracun, iznos){
		return $.dsDirectCall({
			method: "ProrUtrSUpisiIzGrida",
			params: [prorUtr, proracun, iznos]
	    });
	}	

	function ProrUtrZakljucavanje(prorUtr, vrstaIzv, status){
		return $.dsDirectCall({
			method: "ProrUtrZakljucavanje",
			params: [prorUtr, vrstaIzv, status]
	    });
	}	

	function ProrUtrPromjenaStatusa(prorUtr, vrstaIzvrsenja, noviStatus, statusOpcija, napomena){
		return $.dsDirectCall({
			method: "ProrUtrPromjenaStatusa",
			params: [prorUtr, vrstaIzvrsenja, noviStatus, statusOpcija, napomena]
	    });
	}	
	
	function ProrUtrPostojiVezaGS(prorUtr){
		return $.dsDirectCall({
			method: "ProrUtrPostojiVezaGS",
			params: [prorUtr]
	    });
	}	

	function ProrUtrUpisaniIznosiOdobrenja(prorUtr, opcStatusa){
		return $.dsDirectCall({
			method: "ProrUtrUpisaniIznosiOdobrenja",
			params: [prorUtr, opcStatusa]
	    });
	}	

	function ProrUtrObrisi(prorUtr){
		return $.dsDirectCall({
			method: "ProrUtrObrisi",
			params: [prorUtr]
	    });
	}

	function ProrUtrSObrisi(prorUtrS){
		return $.dsDirectCall({
			method: "ProrUtrSObrisi",
			params: [prorUtrS]
	    });
	}	

	function GetProrUtrSFields(prorUtr, vrstaZI, paramPoziv){
		return $.dsDirectCall({
	        method: "GetProrUtrSFields",
	        params: [prorUtr, vrstaZI, paramPoziv]
	    });
	}

	function GetRuKorUgFields(){
		return $.dsDirectCall({
	        method: "GetRuKorUgFields"
	    });
	}

	function GetRuRacunFields(){
		return $.dsDirectCall({
	        method: "GetRuRacunFields"
	    });
	}

	function GetRuRacunSFields(){
		return $.dsDirectCall({
	        method: "GetRuRacunSFields"
	    });
	}
 
	function GetRuZahtjevFields(rutipunosa, vrstaprikaza){
		return $.dsDirectCall({
	        method: "GetRuZahtjevFields",
			params: [rutipunosa, vrstaprikaza]
	    });
	}

	function GetRuZahtjevSFields(rutipunosa){
		return $.dsDirectCall({
	        method: "GetRuZahtjevSFields",
			params: [rutipunosa]
	    });
	}
	
	function RUZahtjevSLista(ruzahtjev, rugovor, opcije){
		return $.dsDirectCall({
			method: "gs/RUZahtjevSLista",
			params: [ ruzahtjev, rugovor, opcije ]
		});
	}
	
	function GotovoObrisi(gotovo){
		return $.dsDirectCall({
			method: "GotovoObrisi",
			params: [ gotovo ]
		});
	}
	
	function GotovoSkupniUnosIspravak(datumStari, datum, vrsta, godina){	
        return $.dsDirectCall({
            method: "GotovoSkupniUnosIspravak",
            params: [ datumStari, datum, vrsta, godina ] 
        });
    }

	function GetIopSFields(){
		return $.dsDirectCall({
	        method: "GetIopSFields"
	    });
	}
	
	function IopSObrisi(iops){
		return $.dsDirectCall({
			method: "IopsObrisi",
			params: [iops]
		});
	}
	
	function IopObrisi(iop){
		return $.dsDirectCall({
			method: "IopObrisi",
			params: [iop]
		});	
	}

	function GetIopNAFields(){
		return $.dsDirectCall({
	        method: "GetIopNAFields"
	    });
	}

	function IopNAObrisi(iopNA){
		return $.dsDirectCall({
			method: "IopNAObrisi",
			params: [iopNA]
		});
	}
	
	function RuGrupaSifra(ruGrupaPopis){
		return $.dsDirectCall({
			method: "RuGrupaSifra",
			params: [ruGrupaPopis]
		});
	}
	
	function PregledIsplaceno(params){
		return $.dsDirectCall({
			method: "pregledIsplaceno",
			params: params
		});
	}
	
	function PregledIsplacenoDob(params){
		return $.dsDirectCall({
			method: "pregledIsplacenoDob",
			params: params
		});
	}
	
	function GetRUgovorSFields(rugovor, ruTipUnosa){
	    return $.dsDirectCall({
	        method: "GetRUgovorSFields",
			params: [rugovor, ruTipUnosa]
	    });
    }
    
	function GetRiznicaSFields(liRiznica, liRUgovor){
	    return $.dsDirectCall({
	        method: "GetRiznicaSFields",
			params: [liRiznica, liRUgovor]
	    });
    }

	function GetIopFields(liRUgovor){
	    return $.dsDirectCall({
	        method: "GetIopFields",
			params: [liRUgovor]
	    });
    }

	function GetRUgovorParFields(liRUgovor){
	    return $.dsDirectCall({
	        method: "GetRUgovorParFields",
			params: [liRUgovor]
	    });
    }

    function GetPovijestSFields(){
    	return $.dsDirectCall({
    		method: "GetPovijestSFields"
    	});	
    }
    
    function GetRUgovorZadnji(liRUg){
    	return $.dsDirectCall({
    		method: "GetRUgovorZadnji",
    		params: [liRUg] 
    	});
    }
    
    function RUgovorSObrisi(rUgovorS){
    	return $.dsDirectCall({
    		method: "RUgovorSObrisi",
    		params: [rUgovorS]
    	});
    }
    
    function RUgovorSSkupnoObrisi(rUgovorS){
    	return $.dsDirectCall({
    		method: "RUgovorSSkupnoObrisi",
    		params: [rUgovorS]
    	});
    }

    function RUgovorSZakljucaj(rugovor, zakljucaj){
		return $.dsDirectCall({
			method: "RUgovorSZakljucaj",
			params: [rugovor, zakljucaj]
		});
	}
    
	function RUgovorObrisi(rUgovor){
		return $.dsDirectCall({
			method: "RUgovorObrisi",
			params: [rUgovor]
		});
	} 

	function RUgovorGetLabelCaption(rUgovor, dodajNazivPartnera){
		return $.dsDirectCall({
			method: "gs/RUgovorGetLabelCaption",
			params: [rUgovor, dodajNazivPartnera]
		});
	}

	function RUgovorSGetLabelCaption(rUgovorS){
		return $.dsDirectCall({
			method: "RUgovorSGetLabelCaption",
			params: [rUgovorS]
		});
	}

	function RUgovorKreirajMjestoTroska(rUgovor){
		return $.dsDirectCall({
			method: "RUgovorKreirajMjestoTroska",
			params: [rUgovor]
		});
	} 

	function PrikaziRuShemuKnjizenja(ruGrupa){
		return $.dsDirectCall({
			method: "gs/PrikaziRuShemuKnjizenja",
			params: [ ruGrupa ]
		});
	}
	
	function ProtuZaSaldaFields(){
		return $.dsDirectCall({
			method: "ProtuZaSaldaFields"
		});
	} 

	function OpomeneZaSaldaFields(){
		return $.dsDirectCall({
			method: "OpomeneZaSaldaFields"
		});
	} 
	
	function RnUplataZaSaldaFields(){
		return $.dsDirectCall({
			method: "RnUplataZaSaldaFields"
		});
	}
	
	function GetSaldaTrFields(){
		return $.dsDirectCall({
			method: "GetSaldaTrFields"
		});
	}
	
	function GetSTrosakFields(){
		return $.dsDirectCall({
			method: "GetSTrosakFields"
		});
	}
	
	function PdvKnjigaNazivPartneraCaption(porijeklo, godina, dokum, brojDokumenta, brojStavke){
		return $.dsDirectCall({
			method: "PdvKnjigaNazivPartneraCaption",
			params: [ porijeklo, godina, dokum, brojDokumenta, brojStavke ]
		});
	}
	
	function PdvKnjigaSZaSaldaFields(){
		return $.dsDirectCall({
			method: "PdvKnjigaSZaSaldaFields"
		});
	}
	
	function PdvKnjigaSPostoNeMozeCaption(postoNeMoze, isporukaPlusIsporukaNeMoze, porezPlusPorezNeMoze, pdv){
		return $.dsDirectCall({
			method: "PdvKnjigaSPostoNeMozeCaption",
			params: [ postoNeMoze, isporukaPlusIsporukaNeMoze, porezPlusPorezNeMoze, pdv ]
		});
	}
	
    function PdvKnjigaSSetAfterPolje(polje, pdvKnjigaS, novi, errorOverride){
        return $.dsDirectCallPost({
            method: "PdvKnjigaSSetAfterPolje",
            controller: "pdvKnjigaS",
            params: [ polje, novi ],
            data: [ pdvKnjigaS ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
                //ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
            }
        });         
    }
	
	function PdvKnjigaOZaPdvFields(){
		return $.dsDirectCall({
			method: "PdvKnjigaOZaPdvFields"
		});
	}

	function PdvObrObrisi(godina, datum1){
		return $.dsDirectCall({
			method: "PdvObrObrisi",
			params: [ godina, datum1 ]
		});
	}

	function PdvObrMogucaObrada(radnja, godina, datum1){
		return $.dsDirectCall({
			method: "PdvObrMogucaObrada",
			params: [ radnja, godina, datum1 ]
		});
	}

    function PdvObrObradaPitanja(radnja, godina, datum1){
		return $.dsDirectCall({
			method: "PdvObrObradaPitanja",
			params: [ radnja, godina, datum1 ]
		});
	}

	function PdvObrAzuriraj(godina, datum1, radnja, nazivRadnje){
		return $.dsDirectCall({
			method: "PdvObrAzuriraj",
			params: [ godina, datum1, radnja, nazivRadnje ]
		});
	}

	function PdvStMoguceBrisanje(godina, datum1, redni){
		return $.dsDirectCall({
			method: "PdvStMoguceBrisanje",
			params: [ godina, datum1, redni ]
		});
	}

    function PdvStBrisanjePitanja(godina, datum1, redni){
		return $.dsDirectCall({
			method: "PdvStBrisanjePitanja",
			params: [ godina, datum1, redni ]
		});
	}
	
	function PdvStObrisi(godina, datum1, redni){
		return $.dsDirectCall({
			method: "PdvStObrisi",
			params: [ godina, datum1, redni ]
		});
	}

	function SaldaMoguceBrisanje(salda, verzija){
		if (verzija == undefined) verzija = 0;
		return $.dsDirectCall({
			method: "SaldaMoguceBrisanje",
			params: [ salda, verzija ]
		});
	}
	
	function SaldaMogucaPromjenaStatusa(arrSalda){
		return $.dsDirectCall({
			method: "SaldaMogucaPromjenaStatusa",
			params: [ arrSalda ]
		});
	}
	
	function SaldaObrisi(salda){
		return $.dsDirectCall({
			method: "SaldaObrisi",
			params: [ salda ]
		});
	}
	
	function PdvKnjigaZaDokument(porijeklo, knjigaSalda){
		return $.dsDirectCall({
			method: "PdvKnjigaZaDokument",
			params: [ porijeklo, knjigaSalda ]
		});
	}
	
	function PdvVrstaById(godina, pdvVrsta){
		return $.dsDirectCall({
			method: "PdvVrstaById",
			params: [ godina, pdvVrsta ]
		});
	}
	
	function PdvKnjigaObrisi(godina, pdvVrsta, redni){
		return $.dsDirectCall({
			method: "PdvKnjigaObrisi",
			params: [ godina, pdvVrsta, redni ]
		});
	}
	
	
	function PdvKnjigaAzurirajRedneBrojeveDaSlijedeDatumKnjige(godina, pdvVrsta){
		return $.dsDirectCall({
			method: "PdvKnjigaAzurirajRedneBrojeveDaSlijedeDatumKnjige",
			params: [ godina, pdvVrsta ]
		});
	}
	
	function PdvKnjigaSZaKnjigaFields(){
		return $.dsDirectCall({
			method: "PdvKnjigaSZaKnjigaFields"
		});
	}
	
	function PdvKnjigaOZaPdvFields(){
		return $.dsDirectCall({
			method: "PdvKnjigaOZaPdvFields"
		});
	}
	
	function KnjigaMoguceBrisanje(knjiga){
		return $.dsDirectCall({
			method: "KnjigaMoguceBrisanje",
			params: [ knjiga ]
		});
	}

	function KnjigaObrisi(knjiga){
		return $.dsDirectCall({
			method: "KnjigaObrisi",
			params: [ knjiga ]
		});
	}
	
	function ProtuPredlozakMoguceBrisanje(knjiga){
		return $.dsDirectCall({
			method: "ProtuPredlozakMoguceBrisanje",
			params: [ knjiga ]
		});
	}	
	function ProtuPredlozakObrisi(salda){
		return $.dsDirectCall({
			method: "ProtuPredlozakObrisi",
			params: [ salda ]
		});
	}
	
	
	function ProtuMoguceKnjizenjeSaldaZatvaraRUVanbil(salda){
		return $.dsDirectCall({
			method: "ProtuMoguceKnjizenjeSaldaZatvaraRUVanbil",
			params: [ salda ]
		});
	}
	
	function ProtuMoguceBrisanjeRUVanbil(salda){
		return $.dsDirectCall({
			method: "ProtuMoguceBrisanjeRUVanbil",
			params: [ salda ]
		});
	}
	
	function ProtuObrisiKnjiziRuVanbil(salda){
		return $.dsDirectCall({
			method: "ProtuObrisiKnjiziRuVanbil",
			params: [ salda ]
		});
	}

	function ProtuObrisiRuVanbil(salda){
		return $.dsDirectCall({
			method: "ProtuObrisiRuVanbil",
			params: [ salda ]
		});
	}

	function ProtuKnjiziRuVanbil(salda){
		return $.dsDirectCall({
			method: "ProtuKnjiziRuVanbil",
			params: [ salda ]
		});
	}


	function ProvjeriBrisanjeProtuNerasknjizen(knjiga){
		return $.dsDirectCall({
			method: "ProvjeriBrisanjeProtuNerasknjizen",
			params: [ knjiga ]
		});
	}

	function ProtuMoguceBrisanje(knjiga, brisanjeNerasknjizenog){
		return $.dsDirectCall({
			method: "ProtuMoguceBrisanje",
			params: [ knjiga, brisanjeNerasknjizenog ]
		});
	}

	function ProtuObrisi(knjiga){
		return $.dsDirectCall({
			method: "ProtuObrisi",
			params: [ knjiga ]
		});
	}
	
	function GetNextGkBrojDokumenta(dokum, organ){
		return $.dsDirectCall({
			method: "GetNextGkBrojDokumenta",
			params: [ dokum, organ ]
		});
	}
	
	function GetNextGkBrojStavke(dokum, brojDokumenta){
		return $.dsDirectCall({
			method: "GetNextGkBrojStavke",
			params: [ dokum, brojDokumenta ]
		});
	}
	
	function GetKontoKD(KD){
		return $.dsDirectCall({
			method: "GetKontoKD",
			params: [ KD ]
		});
	}
	
	function SaldoDokumentaKnjiga(dokum, brojDokumenta){
		return $.dsDirectCall({
			method: "SaldoDokumentaKnjiga",
			params: [ dokum, brojDokumenta ]
		});
	}
	
    function KnjigaIzrSaldo(dokum, brojDokumenta){
        return $.dsDirectCall({
            method: "KnjigaIzrSaldo",
            params: [ dokum, brojDokumenta ]
        });
    }

	function PdvKnjigaDuploCaption(dokum, brojDokumenta, novi){
		return $.dsDirectCall({
			method: "PdvKnjigaDuploCaption",
			params: [ dokum, brojDokumenta, novi ]
		});
	}
	
	function PdvKnjigaPartnerCaption(godina, porijeklo, dokum, brojDokumenta, brojStavke, partner){
		return $.dsDirectCall({
			method: "PdvKnjigaPartnerCaption",
			params: [ godina, porijeklo, dokum, brojDokumenta, brojStavke, partner ]
		});
	}
	
	function PdvKnjigaPdvIraCaption(godina, dokum, brojDokumenta, brojStavke, pdvVrsta, redni){
		return $.dsDirectCall({
			method: "PdvKnjigaPdvIraCaption",
			params: [ godina, dokum, brojDokumenta, brojStavke, pdvVrsta, redni ]
		});
	}
	
	function PdvKnjigaDatumPdvEnabled(godina, porijeklo, dokum, pdvVrsta, redni, brojDokumenta, brojStavke){
		return $.dsDirectCall({
			method: "PdvKnjigaDatumPdvEnabled",
			params: [ godina, porijeklo, dokum, pdvVrsta, redni, brojDokumenta, brojStavke ]
		});
	}
	
	function PdvKnjigaSetAfterPolje(polje, pdvKnjiga, errorOverride){
        return $.dsDirectCallPost({
            method: "PdvKnjigaSetAfterPolje",
            controller: "pdvKnjiga",
            params: [ polje ],
            data: [ pdvKnjiga ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
                //ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
            }
        });         
    }
	
	function SaldaById(salda){
		return $.dsDirectCall({
			method: "SaldaById",
			params: [ salda ]
		});
	}
	
	function GetNextPdvKnjigaRedni(pdvVrsta){
		return $.dsDirectCall({
			method: "GetNextPdvKnjigaRedni",
			params: [ pdvVrsta ]
		});
	}
	
	function PartnerSkracenoPlusOIB(partner){
		return $.dsDirectCall({
			method: "PartnerSkracenoPlusOIB",
			params: [ partner ]
		});
	}
	
	function GetKnjigaIdZaPrvuProtu(salda){
		return $.dsDirectCall({
			method: "GetKnjigaIdZaPrvuProtu",
			params: [ salda ]
		});
	}
	
	function GetPredlozakZaPartnera(partner){
		return $.dsDirectCall({
			method: "GetPredlozakZaPartnera",
			params: [ partner ]
		});
	}

	function PredloziSaldaZaKonto(otvara, godina, konto){
		return $.dsDirectCall({
			method: "PredloziSaldaZaKonto",
			params: [ otvara, godina, konto ]
		});
	}
	
	function SaldoDokumenta(dokum, brojDokumenta){
		return $.dsDirectCall({
			method: "SaldoDokumenta",
			params: [ dokum, brojDokumenta ]
		});
	}
	
	function GetNextBrojDokumenta(dokum, organ){
		return $.dsDirectCall({
			method: "GetNextBrojDokumenta",
			params: [ dokum, organ ]
		});
	}
	
	function GetNextBrojStavke(dokum, brojDokumenta){
		return $.dsDirectCall({
			method: "GetNextBrojStavke",
			params: [ dokum, brojDokumenta ]
		});
	}
	
	function KnjigaById(knjiga){
		return $.dsDirectCall({
			method: "KnjigaById",
			params: [ knjiga ]
		});
	}
	
	function GetMaxKonto(konto){
		return $.dsDirectCall({
			method: "GetMaxKonto",
			params: [ konto ]
		});
	}
	
	function DokumById(dokum){
		return $.dsDirectCall({
			method: "DokumById",
			params: [ dokum ]
		});
	}
	
	function KontoById(konto){
		return $.dsDirectCall({
			method: "KontoById",
			params: [ konto ]
		});
	}
	
	function KontoNoviValidatePostoji(konto, kontoNovi){
		return $.dsDirectCall({
			method: "gs/KontoNoviValidatePostoji",
			params: [ konto, kontoNovi ]
		});
	}
	
	function GetBrojDokumenta(dokum, opcije, tablica){
		return $.dsDirectCall({
			method: "GetBrojDokumenta",
			params: [ dokum, opcije, tablica ]
		});
	}
		
	function SaldaZaNovi(salda, predlozak, lsInd){
		if (predlozak == undefined) predlozak = 0;
		if (lsInd == undefined) lsInd = '0';
		return $.dsDirectCall({
			method: "SaldaZaNovi",
			params: [ salda, predlozak, lsInd]
		});
	}
	
	function SalOtvoreneZaSalda(salda, kojiParam, neDokum, neBrojDokumenta, neBrojStavke){
		if (kojiParam == undefined) kojiParam = '';
		if (neDokum== undefined) neDokum = '';
		if (neBrojDokumenta== undefined) neBrojDokumenta = 0;
		if (neBrojStavke== undefined) neBrojStavke = 0;
		return $.dsDirectCall({
			method: "SalOtvoreneZaSalda",
			params: [ salda, kojiParam, neDokum, neBrojDokumenta, neBrojStavke ]
		});
	}

	function GetSalOtvoreneSaldo(partner, samoOtvorene, konto, samoOtvara, poZPartneru){
		return $.dsDirectCall({
			method: "GetSalOtvoreneSaldo",
			params: [ partner, samoOtvorene, konto, samoOtvara, poZPartneru ]
		});
	}

	function GetSalOtvoreneFields(partner, samoOtvorene, konto, samoOtvara, poZPartneru){
		return $.dsDirectCall({
			method: "GetSalOtvoreneFields",
			params: [ partner, samoOtvorene, konto, samoOtvara, poZPartneru ]
		});
	}

	function SaldaZaUzDokument(salda, dokum, dokument, prviPredlozakZaPartnera){
		if (dokument == undefined) dokument = 0;
		return $.dsDirectCall({
			method: "SaldaZaUzDokument",
			params: [ salda, dokum, dokument, prviPredlozakZaPartnera ]
		});
	}

	function PredlozakSById(predlozakS){
		return $.dsDirectCall({
			method: "PredlozakSById",
			params: [ predlozakS ]
		});
	}
	
	function ObrisiPredlozakZaDokum(lsPorijeklo, liId){
		return $.dsDirectCall({
			method: "ObrisiPredlozakZaDokum",
			params: [ lsPorijeklo, liId ]
		});
	}
	
    function RuRacunObrisi(ruRacun){
    	return $.dsDirectCall({
    		method: "RuRacunObrisi",
    		params: [ruRacun]
    	});
    }

    function RuRacunSObrisi(ruRacunS){
    	return $.dsDirectCall({
    		method: "RuRacunSObrisi",
    		params: [ruRacunS]
    	});
    }
	
    function RuZahtjevObrisi(ruZahtjev){
    	return $.dsDirectCall({
    		method: "RuZahtjevObrisi",
    		params: [ruZahtjev]
    	});
    }

    function RuZahtjevObrisiSkupno(ruZahtjev){
    	return $.dsDirectCall({
    		method: "RuZahtjevObrisiSkupno",
    		params: [ruZahtjev]
    	});
    }

    function RuZahtjevSObrisi(ruZahtjevS){
    	return $.dsDirectCall({
    		method: "RuZahtjevSObrisi",
    		params: [ruZahtjevS]
    	});
    }

	function PredloziIznosPredujma(rugovor){
        return $.dsDirectCall({
            method: "PredloziIznosPredujma",
            params: [ rugovor ]
        });  
	}

	function RuRacunSById(ruRacunS){
		return $.dsDirectCall({
			method: "RuRacunSById",
			params: [ ruRacunS ]
		});
	}
	
	function RUgovorSById(rUgovorS){
		return $.dsDirectCall({
			method: "RUgovorSById",
			params: [ rUgovorS ]
		});
	}

	function RUgovorSZNSById(rUgovorS){
		return $.dsDirectCall({
			method: "RUgovorSZNSById",
			params: [ rUgovorS ]
		});
	}

	function RUgovorZNS(rUgovor){
		return $.dsDirectCall({
			method: "RUgovorZNS",
			params: [ rUgovor ]
		});
	}

	function RUZStatusById(ruzstatus){
		return $.dsDirectCall({
			method: "RUZStatusById",
			params: [ ruzstatus ]
		});
	}

	function RUgovorSZaRuRacunS(ruRacunS){
		return $.dsDirectCall({
			method: "RUgovorSZaRuRacunS",
			params: [ ruRacunS ]
		});
	}
	
	function RuRacunById(ruRacun){
		return $.dsDirectCall({
			method: "RuRacunById",
			params: [ ruRacun ]
		});
	}
	
    function RuKorUgObrisi(ruKorUg){
    	return $.dsDirectCall({
    		method: "RuKorUgObrisi",
    		params: [ruKorUg]
    	});
    }
	
 	function ProvjeriDatumeRn(ruZahtjev, ruRacun){
		return $.dsDirectCall({
			method: "ProvjeriDatumeRn",
			params: [ ruZahtjev, ruRacun ]
		});
	}

	function PostojiVanbilancnoZaduzenjeRU(rugovor){
		return $.dsDirectCall({
			method: "PostojiVanbilancnoZaduzenjeRU",
			params: [ rugovor ]
		});
	}
	
	function KnjiziRuZaduzenjeVanbil(rugovor){
		return $.dsDirectCall({
			method: "KnjiziRuZaduzenjeVanbil",
			params: [ rugovor ]
		});
	}

	function StornoRuZaduzenjeVanbil(rugovor){
		return $.dsDirectCall({
			method: "StornoRuZaduzenjeVanbil",
			params: [ rugovor ]
		});
	}

	
	function RUgovorSaldoPo(rUgovor, ruGrupaL){
		return $.dsDirectCall({
			method: "RUgovorSaldoPo",
			params: [ rUgovor, ruGrupaL ]
		});
	}
	
	function ProvjeriPartnerObaveznoIPostoji(partner){
		return $.dsDirectCall({
			method: "ProvjeriPartnerObaveznoIPostoji",
			params: [ partner ]
		});
	}
	
	function DajSaldaZaStariPK(godina, dokum, brojDokum, brojStavke){
		return $.dsDirectCall({
			method: "DajSaldaZaStariPK",
			params: [ godina, dokum, brojDokum, brojStavke ]
		});	
	}
	
	function GetRUgovorVezaFields(){
		return $.dsDirectCall({
			method: "GetRUgovorVezaFields"
		});
	} 
	
	function RUgovorVezaObrisi(rUgovorVeza){
		return $.dsDirectCall({
			method: "RUgovorVezaObrisi",
			params: [rUgovorVeza]
		});
	}
	
	function PredlozakImaVezuInteract(ciPredlozak){
		return $.dsDirectCall({
			method: "PredlozakImaVezuInteract",
			params: [ ciPredlozak ]
		});
	}
	
	function PredlozakSImaVezuInteract(ciPredlozakS){
		return $.dsDirectCall({
			method: "PredlozakSImaVezuInteract",
			params: [ ciPredlozakS ]
		});	
	}
	
	function PredlozakObrisi(ciPredlozak, brisiVeze){
		return $.dsDirectCall({
			method: "PredlozakObrisi",
			params: [ ciPredlozak, brisiVeze ]
		});	
	}
	
	function PredlozakSObrisi(ciPredlozakS, ciPredlozak, brisiVeze){
		return $.dsDirectCall({
			method: "PredlozakSObrisi",
			params: [ ciPredlozakS, ciPredlozak, brisiVeze ]
		});	
	}
	
	function PVTroskaObrisi(pvtroska){
		return $.dsDirectCall({
			method: "PVTroskaObrisi",
			params: [pvtroska]
		});
	}
	
	function KnjigaSetAfterPolje(novi, polje, knjiga){
		return $.dsDirectCall({
			method: "KnjigaSetAfterPolje",
			params: [ novi, polje, knjiga ]
		});
	}
	
	function KnjigaSetAfterMTroska(novi, mtroska, organ){
		return $.dsDirectCall({
			method: "KnjigaSetAfterMTroska",
			params: [ novi, mtroska, organ ]
		});
	}

	function KnjigaSetAfterOrgan(novi, organ, mtroska){
		return $.dsDirectCall({
			method: "KnjigaSetAfterOrgan",
			params: [ novi, organ, mtroska ]
		});
	}

    function KopiranjeSetAfterPolje(polje, kopiranje, errorOverride){
            return $.dsDirectCallPost({
                method: "KopiranjeSetAfterPolje",
                controller: "kopiranje",
                params: [ polje ],
                data: [ kopiranje ],
                fail: function (error, textStatus, jqXHR, logicalError){ 
                    if (errorOverride){
                        jqXHR.statusText = "errorOverride"; 
                    }
                    //ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
                }
            });         
    }
    
    function KopiranjeBeforePost(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "KopiranjeBeforePost",
            controller: "kopiranje",
            params: [ ],
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
                //ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
            }
        });         
    }

	function DajNazivZaKlasuKonta(konto){
		return $.dsDirectCall({
			method: "gs/DajNazivZaKlasuKonta",
			params: [ konto ]
		});
	}
	
	function DajKlasu(konto){
		return $.dsDirectCall({
			method: "gs/DajKlasu",
			params: [ konto ]
		});
	}
	
	function KontoObrisi(konto){
		return $.dsDirectCall({
			method: "KontoObrisi",
			params: [ konto ]
		});
	}
	
	function GetPNabaveSFields(){
		return $.dsDirectCall({
			method: "GetPNabaveSFields"
	    });
	}	
	
	function GetPNabaveFields(){
		return $.dsDirectCall({
			method: "GetPNabaveFields"
	    });
	}
	
    function PNabaveById(pnabave){
        return $.dsDirectCall({
            method: "PNabaveById",
            params: [ pnabave ]
        });
    }	

	function PNabaveSById(pnabaves){
		return $.dsDirectCall({
			method: "gs/PNabaveSById",
			params: [ pnabaves ]
		});
	}

	function PNabaveSNazivById(pnabaves){
		return $.dsDirectCall({
			method: "PNabaveSNazivById",
			params: [ pnabaves ]
		});
	}

	function PNabaveSRenumerirajStavke(pnabave){
		return $.dsDirectCall({
			method: "PNabaveSRenumerirajStavke",
			params: [ pnabave ]
		});
	}	

	function PNabaveSProvjeriOvlastenjaNaOjMt(pnabave, pnabaves, radnja){
		return $.dsDirectCall({
			method: "gs/PNabaveSProvjeriOvlastenjaNaOjMt",
			params: [ pnabave, pnabaves, radnja ]
		});
	}

	function GetRaspored(proracun){
		return $.dsDirectCall({
			method: "GetRaspored",
			params: [ proracun ]
		});
	}

	function ProracunSetAfterPolje(proracun, kojePolje){
		return $.dsDirectCallPost({
			method: "ProracunSetAfterPolje",
			controller: "proracun",
			params: [ kojePolje ],
			data: [ proracun ],
			fail: function (error, textStatus, jqXHR, logicalError){				
			}
		});
	}		
	
	function ProracunPlaniranoValidateIspravnoPremaTecajuNaDan(proracun){
		return $.dsDirectCall({
			method: "ProracunPlaniranoValidateIspravnoPremaTecajuNaDan",
			params: [ proracun ]
		});		
	}	
	
	function ProracunPozicijaValidateDozvoljena(pozicija, godina){
		return $.dsDirectCall({
			method: "ProracunPozicijaValidateDozvoljena",
			params: [ pozicija, godina ]
		});		
	}	
	function ProracunPitanjePrijeGeneriranjaAzuriranjaStavkiPlana(planProrID, azuriranje){
		return $.dsDirectCall({
			method: "ProracunPitanjePrijeGeneriranjaAzuriranjaStavkiPlana",
			params: [ planProrID, azuriranje ]
		});		
	}
	
	function ProracunGenerirajStavkePremaKontimaUGK(godina, planProrID, poKontuIzvrsenja){
		return $.dsDirectCall({
			method: "ProracunGenerirajStavkePremaKontimaUGK",
			params: [ godina, planProrID, poKontuIzvrsenja ]
		});		
	}

	function ProracunOtvoriProracunSa0(planProrID, datumDo, realPodMT, realPodOrgan, upisi){
		return $.dsDirectCall({
			method: "ProracunOtvoriProracunSa0",
			params: [ planProrID, datumDo, realPodMT, realPodOrgan, upisi ]
		});
	}
	
	function ProracunUpisiAzurirajStavkaPlanaZaPlan(planProrID, samoOneKojiNemajuUpisanoStavkaPlana, samoOneKojiImajuUpisanoStavkaPlana){
		return $.dsDirectCall({
			method: "ProracunUpisiAzurirajStavkaPlanaZaPlan",
			params: [ planProrID, samoOneKojiNemajuUpisanoStavkaPlana, samoOneKojiImajuUpisanoStavkaPlana ]
		});		
	}
	function ProracunPitanjePrijeBrisanjaStavkiPlana(planProrID){
		return $.dsDirectCall({
			method: "ProracunPitanjePrijeBrisanjaStavkiPlana",
			params: [ planProrID ]
		});		
	}
	
	function ProracunObrisiStavkePlana(planProrID){
		return $.dsDirectCall({
			method: "ProracunObrisiStavkePlana",
			params: [ planProrID ]
		});		
	}
	
	function ProrKonSetAfterPolje(prorKon, kojePolje){
		return $.dsDirectCallPost({
			method: "ProrKonSetAfterPolje",
			controller: "prorKon",
			params: [ kojePolje ],
			data: [ prorKon ],
			fail: function (error, textStatus, jqXHR, logicalError){				
			}
		});
	}	

  	function OvlastenjeDeaktiviraj(ovlastenje){
  		return $.dsDirectCall({
  			method: "OvlastenjeDeaktiviraj",
  			params: [ ovlastenje ]
  		});
	  }
	
	function GetPlanProrSume(planPror, opcijePlana){
		return $.dsDirectCall({
			method: "GetPlanProrSume",
			params: [planPror, opcijePlana]
	    });
	}
  	  	  
  	function ImportPlanProrXls(obj){
		return $.dsDirectCall({
			method: "ImportPlanProrXls",
			params: [ obj ]
		});
	}	  

	function RiznicaById(riznica){
		return $.dsDirectCall({
			method: "gs/RiznicaById",
			params: [ riznica ]
		});
	}

	function RiznicaSById(riznica, riznicas){
		return $.dsDirectCall({
			method: "gs/RiznicaSById",
			params: [ riznica, riznicas ]
		});
	}

	function RUgovorZaRiznica(riznica){
		return $.dsDirectCall({
			method: "gs/RUgovorZaRiznica",
			params: [ riznica ]
		});
	}

	function RUgovorIzDokument(dok){
		return $.dsDirectCall({
			method: "gs/RUgovorIzDokument",
			params: [ dok ]
		});
	}

	function RizDokById(rizdok){
		return $.dsDirectCall({
			method: "gs/RizDokById",
			params: [ rizdok ]
		});
	}
	
	function RizDokSapById(rizdoksap){
		return $.dsDirectCall({
			method: "gs/RizDokSapById",
			params: [ rizdoksap ]
		});
	}

	function PozicijaById(godina, pozicija){
		return $.dsDirectCall({
			method: "gs/PozicijaById",
			params: [ godina, pozicija ]
		});
	}
	
	function ProvjeriAktivanZR(partner, ziro){
		return $.dsDirectCall({
			method: "ProvjeriAktivanZR",
			params: [partner, ziro]
		});
	}	

    function OtpremaObrisi(otprema){
    	return $.dsDirectCall({
    		method: "OtpremaObrisi",
    		params: [otprema]
    	});
    }
    
    function OtpremaSetAfterPolje(otprema, kojePolje){
		return $.dsDirectCallPost({
			method: "OtpremaSetAfterPolje",
			controller: "otprema",
			params: [ kojePolje ],
			data: [ otprema ],
			fail: function (error, textStatus, jqXHR, logicalError){				
			}
		});
	}
	
	function GetOtpremaSFields(otprema, vrsta){
	    return $.dsDirectCall({
	        method: "GetOtpremaSFields",
			params: [otprema, vrsta]
	    });
    }
        
    function OtpremaSObrisi(otpremaS){
    	return $.dsDirectCall({
    		method: "OtpremaSObrisi",
    		params: [otpremaS]
    	});
    }
    
    function OtpremaSZakljucaj(otprema, zakljucaj){
		return $.dsDirectCall({
			method: "OtpremaSZakljucaj",
			params: [otprema, zakljucaj]
		});
	}
    	 
	function OtpremaSById(otpremaS){
		return $.dsDirectCall({
			method: "OtpremaSById",
			params: [ otpremaS ]
		});
	}

	function OtpremaSSetAfterPolje(otpremaS, kojePolje){
		return $.dsDirectCallPost({
			method: "OtpremaSSetAfterPolje",
			controller: "otpremaS",
			params: [ kojePolje ],
			data: [ otpremaS ],
			fail: function (error, textStatus, jqXHR, logicalError){				
			}
		});
	}

    function RjesenjeObrisi(rjesenje){
    	return $.dsDirectCall({
    		method: "RjesenjeObrisi",
    		params: [rjesenje]
    	});
    }

	function GetRjRedakFields(rjesenje){
	    return $.dsDirectCall({
	        method: "GetRjRedakFields",
			params: [rjesenje]
	    });
    }

    function RjRedakObrisi(rjesenje,redak){
    	return $.dsDirectCall({
    		method: "RjRedakObrisi",
    		params: [rjesenje,redak]
    	});
    }

	function IzvoriById(izvori, godina){
		return $.dsDirectCall({
			method: "gs/IzvoriById",
			params: [ izvori, godina ]
		});
	}

	function IzvoriGrupaIzvjestajById(izvori, godina){
		return $.dsDirectCall({
			method: "gs/IzvoriGrupaIzvjestajById",
			params: [ izvoriGrupaIzvjestaj, godina ]
		});
	}

	function IzvoriIzvoriPrihodaById(izvori, godina){
		return $.dsDirectCall({
			method: "gs/IzvoriIzvoriPrihodaById",
			params: [ izvoriIzvoriPrihoda, godina ]
		});
	}
	


	function RUgovorById(rugovor){
		return $.dsDirectCall({
			method: "gs/RUgovorById",
			params: [ rugovor ]
		});
	}

	function PregledUgovorenoZaPNabaveS(params){
		return $.dsDirectCall({
			method: "PregledUgovorenoZaPNabaveS",
			params: params
		});
	}

	function OtpGenerirajSetAfterBtn(otprema, errorOverride){
		return $.dsDirectCallPost({
			method: "otpGenerirajSubmit",
			controller: "otprema",
			params: [  ],
			data: [ otprema ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}
			
		});			
	}

	function OtpGenerirajUPozadiniSetAfterBtn(otprema){
		return $.dsDirectCallPost({
			method: "otpGenerirajUPozadiniSubmit",
			controller: "otprema",
			params: [  ],
			data: [ otprema ]		
		});			
	}

	function GetNaNGrupe(params){
		return $.dsDirectCall({
			method: "GetNaNGrupe",
			params: [ params ]
		});
	} 

	function OtpremaPromStatus(otprema, status, opis, vrDostave){
		return $.dsDirectCall({
			method: "otpremaPromStatus",
			params: [ otprema, status, opis, vrDostave ]
		});
	} 

	function OtpremaPromStatusBezDizanjaErrora(otprema, status, opis, vrDostave){
		return $.dsDirectCall({
			method: "otpremaPromStatus",
			params: [ otprema, status, opis, vrDostave ],
			fail: function (error, textStatus, jqXHR, logicalError) {}	
		});
	} 

	function PNabaveSPreracunajUgovoreno(pnabave, pnabaves){
		return $.dsDirectCall({
			method: "PNabaveSPreracunajUgovoreno",
			params: [ pnabave, pnabaves ]
		});
	}	
	
	function DokumentiPNabaveS(pnabaves, ind){
		return $.dsDirectCall({
	        method: "DokumentiPNabaveS",
			params: [ pnabaves, ind ]	        
	    });
	}

	function ProrUtrPrenesiZahtjevUGs(prorutr, dok, rizDok, trosiRizDok,datDok, datDosp){
		return $.dsDirectCall({
			method: "ProrUtrPrenesiZahtjevUGs",
			params: [ prorutr, dok, rizDok, trosiRizDok, datDok, datDosp ]	
		});
	} 

	function ProrUtrPrenesiZahtjevUGsBezDizanjaErrora(prorutr, dok, rizDok, trosiRizDok, datDok, datDosp){
		return $.dsDirectCall({
			method: "ProrUtrPrenesiZahtjevUGs",
			params: [ prorutr, dok, rizDok, trosiRizDok, datDok, datDosp],
			fail: function (error, textStatus, jqXHR, logicalError) {}		
		});
	} 

	function RuZahtjevPromStatus(ruzahtjev, status, datum, napomena){
		return $.dsDirectCall({
			method: "RuZahtjevPromStatus",
			params: [ ruzahtjev, status, datum, napomena ]
		});
	} 

	function RuZahtjevPromStatusSkupno(ruzahtjev, status, datumDospjeca, atumPlaceno, napomena){
		return $.dsDirectCall({
			method: "RuZahtjevPromStatusSkupno",
			params: [ ruzahtjev, status, datumDospjeca, atumPlaceno, napomena ]
		});
	} 
	
	function KnjigaGenPrihodZaStavku(knjigaId, brojStavke, opis, paramKojaKlasa){
		return $.dsDirectCall({
			method: "KnjigaGenPrihodZaStavku",
			params: [ knjigaId, brojStavke, opis, paramKojaKlasa ]
		});
	} 

	function PNabaveSImportXlsUPozadini(pnabavesimportxls){
		return $.dsDirectCallPost({
			method: "ImportPnabavesXlsUPozadiniSubmit",
			controller: "PNabaveS",
			params: [  ],
			data: [ pnabavesimportxls ]		
		});	
		
	}
	
	function IopImportXlsUPozadini(iopimportxls){
		return $.dsDirectCallPost({
			method: "ImportIopXlsUPozadiniSubmit",
			controller: "Iop",
			params: [  ],
			data: [ iopimportxls ]		
		});	
		
	}
	
	function IzboriDajOpisZaSlijediUPr(slijediUPr){
        return $.dsDirectCall({
            method: "IzboriDajOpisZaSlijediUPr",
            params: [ slijediUPr ]
        });  
	}
	
	function DajObavKnjModel(partner, obavKnj){
        return $.dsDirectCall({
            method: "DajObavKnjModel",
            params: [ partner, obavKnj ]
        });  
	}

	function DajObavKnjZaduzenjeZa(datum){
        return $.dsDirectCall({
            method: "DajObavKnjZaduzenjeZa",
            params: [ datum ]
        });  
	}
	
	function ObavKnjPlusMinusCaption(vrstaOk, osnovica){
		return $.dsDirectCall({
			method: "ObavKnjPlusMinusCaption",
			params: [ vrstaOk, osnovica ]
		});
	}
	
	function ObavKnjPorezIznosCaption(ukupno, osnovica){
		return $.dsDirectCall({
			method: "ObavKnjPorezIznosCaption",
			params: [ ukupno, osnovica ]
		});
	}
	
	function ObavKnjPorezEnabled(datum){
		return $.dsDirectCall({
			method: "ObavKnjPorezEnabled",
			params: [ datum ]
		});
	}
	
	function ObavKnjSetAfterPolje(polje, obavKnj, novi, errorOverride){
        return $.dsDirectCallPost({
            method: "ObavKnjSetAfterPolje",
            controller: "obavKnj",
            params: [ polje, novi ],
            data: [ obavKnj ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
                //ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
            }
        });         
    }
	
	function GetNovaStavka(pnabave, izvanEojn){
        return $.dsDirectCall({
            method: "GetNovaStavka",
            params: [ pnabave, izvanEojn ]
        });  
	}

	function PostojiStavkaZaPNabaveIVerziju(stavka, verzijaStavke, pNabave){
        return $.dsDirectCall({
            method: "PostojiStavkaZaPNabaveIVerziju",
            params: [ stavka, verzijaStavke, pNabave ]
        });  
	}

	function MTroskaKarticaInfo(mtroska, karticaVerzija){
		return $.dsDirectCall({
			method: "gs/MTroskaKarticaInfo",
			params: [ mtroska, karticaVerzija ]
		});
	}

	function OdrediKnjizenjePremaRUgovor(rugovor, godina, rugovors, konto, pozicija, izvori, lokac, podaciPredlozeniIz){
		return $.dsDirectCall({
			method: "gs/OdrediKnjizenjePremaRUgovor",
			params: [ rugovor, godina, rugovors, konto, pozicija, izvori, lokac, podaciPredlozeniIz ]
		});
	}
	
	function OdrediKnjizenjePremaRiznica(trosiriznica, godina, trosiriznicas, konto, pozicija, izvori, lokac, podaciPredlozeniIz){
		return $.dsDirectCall({
			method: "gs/OdrediKnjizenjePremaRiznica",
			params: [ trosiriznica, godina, trosiriznicas, konto, pozicija, izvori, lokac, podaciPredlozeniIz ]
		});
	}
	
	function RUgovorZaOdabirParam(salda, partner, trosiriznica, dokum, datumdospjeca, kontogk){
		return $.dsDirectCall({
			method: "gs/RUgovorZaOdabirParam",
			params: [ salda, partner, trosiriznica, dokum, datumdospjeca, kontogk ]
		});
	}
	
	function RiznicaZaOdabirParam(salda, partner, trosiriznica, rizdokfaktura, datumdospjeca, kontogk){
		return $.dsDirectCall({
			method: "gs/RiznicaZaOdabirParam",
			params: [ salda, partner, trosiriznica, rizdokfaktura, datumdospjeca, kontogk ]
		});
	}

	function PlanProrUpdatePozicije(deaktiviraj, planProrId){		
        return $.dsDirectCall({
            method: "PlanProrUpdatePozicije",
            params: [ deaktiviraj, planProrId ] 
        });
    } 
    
    function PlanProrKopiraj(planPror){
        return $.dsDirectCallPost({
            method: "PlanProrKopiraj",
            params: [ ],
			data: [ planPror ]             
        });
    } 
    
	function PlanProrPitanjaPrijeUpisa(planPror, novi){
        return $.dsDirectCallPost({
            method: "PlanProrPitanjaPrijeUpisa",
            controller: "PlanPror",
            params: [ novi ],
            data: [ planPror ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
                //ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
            }
        }); 
    } 
    
    function ProrPraviloPlanJeZakljucan(planProrID){
        return $.dsDirectCall({
            method: "ProrPraviloPlanJeZakljucan",   
            params: [ planProrID ]           
        }); 
    }  
     
    function ProrPraviloProracunJeZakljucan(proracun){
        return $.dsDirectCall({
            method: "ProrPraviloProracunJeZakljucan",   
            params: [ proracun ]           
        }); 
    }
    
    function ProrPraviloZakljucajOtkljucajPlan(planProrID, zakljucajOtkljucaj){		
        return $.dsDirectCall({
            method: "ProrPraviloZakljucajOtkljucajPlan",   
            params: [ planProrID, zakljucajOtkljucaj ]  
        }); 
    }  
    
    function ProrPraviloZakljucajOtkljucajProracun(proracun, zakljucajOtkljucaj){		
        return $.dsDirectCall({
            method: "ProrPraviloZakljucajOtkljucajProracun",   
            params: [ proracun, zakljucajOtkljucaj ]  
        }); 
    }
    
    function PlanProrPorukaZaProvjeruLimitaPlana(planProrID){		
        return $.dsDirectCall({
            method: "PlanProrPorukaZaProvjeruLimitaPlana",   
            params: [ planProrID ]  
        }); 
    }
    
    function ProrPraviloDajPitanjeZaZakljucavanjeProracuna(proracun){		
        return $.dsDirectCall({
            method: "ProrPraviloDajPitanjeZaZakljucavanjeProracuna",   
            params: [ proracun ]  
        }); 
    }
    
    function PlanProrGetNezakljucaneStavkePlana(planProrID){		
        return $.dsDirectCall({
            method: "PlanProrGetNezakljucaneStavkePlana",   
            params: [ planProrID ]  
        }); 
    }
    
    function ProracunProvjeraLimita(proracun){		
        return $.dsDirectCall({
            method: "ProracunProvjeraLimita",   
            params: [ proracun ]  
        }); 
    } 
    
    function ProrPraviloPlanJeZakljucan(planProrID){
        return $.dsDirectCall({
            method: "ProrPraviloPlanJeZakljucan",   
            params: [ planProrID ]           
        }); 
    }  
     
    function ProrPraviloProracunJeZakljucan(proracun){
        return $.dsDirectCall({
            method: "ProrPraviloProracunJeZakljucan",   
            params: [ proracun ]           
        }); 
    }
    
    function ProrPraviloZakljucajOtkljucajPlan(planProrID, zakljucajOtkljucaj){		
        return $.dsDirectCall({
            method: "ProrPraviloZakljucajOtkljucajPlan",   
            params: [ planProrID, zakljucajOtkljucaj ]  
        }); 
    }  
    
    function ProrPraviloZakljucajOtkljucajProracun(proracun, zakljucajOtkljucaj){		
        return $.dsDirectCall({
            method: "ProrPraviloZakljucajOtkljucajProracun",   
            params: [ proracun, zakljucajOtkljucaj ]  
        }); 
    }
    
    function PlanProrPorukaZaProvjeruLimitaPlana(planProrID){		
        return $.dsDirectCall({
            method: "PlanProrPorukaZaProvjeruLimitaPlana",   
            params: [ planProrID ]  
        }); 
    }
    
    function ProrPraviloDajPitanjeZaZakljucavanjeProracuna(proracun){		
        return $.dsDirectCall({
            method: "ProrPraviloDajPitanjeZaZakljucavanjeProracuna",   
            params: [ proracun ]  
        }); 
    }
    
    function PlanProrGetNezakljucaneStavkePlana(planProrID){		
        return $.dsDirectCall({
            method: "PlanProrGetNezakljucaneStavkePlana",   
            params: [ planProrID ]  
        }); 
    }
    
    function ProracunProvjeraLimita(proracun){		
        return $.dsDirectCall({
            method: "ProracunProvjeraLimita",   
            params: [ proracun ]  
        }); 
    }
    
	function PredloziAktivnostZaProjekt(podrucje){
        return $.dsDirectCall({
            method: "PredloziAktivnostZaProjekt",
            params: [ podrucje ]
        });  
	}

	function PredloziIzvoreZaProjekt(podrucje){
        return $.dsDirectCall({
            method: "PredloziIzvoreZaProjekt",
            params: [ podrucje ]
        });  
	}
	
    function STrosakSetAfterPolje(polje, sTrosak, novi, errorOverride){
            return $.dsDirectCallPost({
                method: "STrosakSetAfterPolje",
                controller: "sTrosak",
                params: [ polje, novi ],
                data: [ sTrosak ],
                fail: function (error, textStatus, jqXHR, logicalError){ 
                    if (errorOverride){
                        jqXHR.statusText = "errorOverride"; 
                    }
                    //ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
                }
            });         
    }
	
	function KnjigaRuPostoji(rugovor, knjiga, salda){		
        return $.dsDirectCall({
            method: "KnjigaRuPostoji",
            params: [ rugovor, knjiga, salda ] 
        });
    } 

	function KnjigaRuVratiRugovor(pozivIz, salda, iRUgovor){		
        return $.dsDirectCall({
            method: "KnjigaRuVratiRugovor",
            params: [ pozivIz, salda, iRUgovor ] 
        });
    } 

	function GenerirajKnjigaRU(iRugovor, sSkGk, iKnjiga, iSalda, bUpisiIznose, bProvjeriNeGeneriraj, bKnjigaRuPostoji){		
        return $.dsDirectCall({
            method: "GenerirajKnjigaRU",
            params: [ iRugovor, sSkGk, iKnjiga, iSalda, bUpisiIznose, bProvjeriNeGeneriraj, bKnjigaRuPostoji ] 
        });
    } 

	function KnjigaRuMoguceBrisanje(knjigaRu) {		
        return $.dsDirectCall({
            method: "KnjigaRuMoguceBrisanje",
            params: [ knjigaRu ] 
        });
    } 

	function KnjigaRuObrisi(knjigaRu, saldaDokum) {		
        return $.dsDirectCall({
            method: "KnjigaRuObrisi",
            params: [ knjigaRu, saldaDokum ] 
        });
    } 

	function KnjigaRuGenerirajIznose(salda, rugovor, rugovorLanac){		
        return $.dsDirectCall({
            method: "KnjigaRuGenerirajIznose",
            params: [ salda, rugovor, rugovorLanac ] 
        });
    }

	function KnjigaRuSalda(salda, knjiga, rugovors, rugovor, saldadokum, gkBrojStavke){
		return $.dsDirectCall({
			method: "KnjigaRuSalda",
			params: [ salda, knjiga, rugovors, rugovor, saldadokum, gkBrojStavke ]
		});
	}

	function GetKnjigaRuFields(rugovor, salda, knjiga, bUkupnoRuS, bUkupnoRuSRaspored){
		return $.dsDirectCall({
            params: [rugovor, salda, knjiga, bUkupnoRuS, bUkupnoRuSRaspored],
            method: "gs/GetKnjigaRuFields"
        });
	}	

	function KnjigaRuZatvori(rugovor, datum, naknadno){
        return $.dsDirectCall({
            method: "KnjigaRuZatvori",
            params: [ rugovor, datum, naknadno ] 
        });
    } 

	function KnjigaRuPredloziNovi(salda, knjiga){
        return $.dsDirectCall({
            method: "KnjigaRuPredloziNovi",
            params: [ salda, knjiga ] 
        });
    } 
    
    function GetHRValutaOznakaNaDan(date){
		return $.dsDirectCall({
			method: "GetHRValutaOznakaNaDan",
			params: [date]
	    });	
	}

	function GetIopValuta(id){
		return $.dsDirectCall({
			method: "GetIopValuta",
			params: [id]
	    });	
	}
	
    function KnjigaRasObrisi(knjigaRas){
        return $.dsDirectCall({
            method: "knjigaRasObrisi",
            params: [ knjigaRas ]
        });
    }

    function GetUkupnoZaPosto(grupa, vrijediOd){
        return $.dsDirectCall({
            method: "GetUkupnoZaPosto",
            params: [ grupa, vrijediOd ]
        });
   }
   
   function KnjigaRasNemaKoloneUNacinu(nacin){
        return $.dsDirectCall({
            method: "KnjigaRasNemaKoloneUNacinu",
            params: [nacin]
        });       
   }
   
	function IzvodShemaPomakniGore(id, prioritet){
		return $.dsDirectCall({
			method: "IzvodShemaPomakniGore",
			params: [id, prioritet]
	    });	
	}
	
	function IzvodShemaPomakniDolje(id, prioritet){
		return $.dsDirectCall({
			method: "IzvodShemaPomakniDolje",
			params: [id, prioritet]
	    });	
	}
	
	function IzvodShemaGetPrioritetZadnjiCaption(){
		return $.dsDirectCall({
			method: "IzvodShemaGetPrioritetZadnjiCaption"
	    });	
	}	
		
	function IzvodShemaGetPrioritetCaption(id, prioritet){
		return $.dsDirectCall({
			method: "IzvodShemaGetPrioritetCaption",
			params: [id, prioritet]
	    });	
	}
	
	function IzvodShemaGetPrioritetPostojiCaption(prioritet){
		return $.dsDirectCall({
			method: "IzvodShemaGetPrioritetPostojiCaption",
			params: [prioritet]
	    });	
	}
		
	
	function GetIzvodSFields(izvod){
		return $.dsDirectCall({
			method: "GetIzvodSFields",
			params: [ izvod ]
		});
	}
	
    function GetProracunSFields(proracun, planPror){
        return $.dsDirectCall({
            method: "GetProracunSFields",
            params: [ proracun, planPror ]
        });
    }		
	
	function GetIzvodSBrisanjePitanje(id){
		return $.dsDirectCall({
			method: "GetIzvodSBrisanjePitanje",
			params: [id]
	    });	
	}	
	
	function GetIzvodSBrisanjePoruka(poruka){
		return $.dsDirectCall({
			method: "GetIzvodSBrisanjePoruka",
			params: [poruka]
	    });	
	}	
	
	function IzvodSObrisi(dataCB){
		return $.dsDirectCall({
			method: "IzvodSObrisi",
			params: [dataCB]
	    });	
	}
	
	function GetKnjizenjeIzvodaCaption(izvodArr, dokum, bankaIzvod){
		return $.dsDirectCall({
			method: "GetKnjizenjeIzvodaCaption",
			params: [izvodArr, dokum, bankaIzvod]
	    });	
	}		
	
	function GetIzvodProknjizitiPitanje(izvodArr, dokum, bankaIzvod){
		return $.dsDirectCall({
			method: "GetIzvodProknjizitiPitanje",
			params: [izvodArr, dokum, bankaIzvod]
	    });	
	}		
	
	function GetIzvodBrisanjePitanje(izvod, dokum, bankaIzvod){
		return $.dsDirectCall({
			method: "GetIzvodBrisanjePitanje",
			params: [izvod, dokum, bankaIzvod]
	    });	
	}		
	
	function IzvodObrisi($id){
		return $.dsDirectCall({
			method: "IzvodObrisi",
			params: [$id]
	    });	
	}
	
	function RUGrupaById(rugrupa){
		return $.dsDirectCall({
			method: "RUGrupaById",
			params: [rugrupa]
	    });
	}

	function GetRUgovorTemplate(rutipunosa){
		return $.dsDirectCall({
			method: "gs/GetRUgovorTemplate",
			params: [ rutipunosa ]
		});
	}
			
			
	function PartnerImaOtvorenihStavaka($id){
		return $.dsDirectCall({
			method: "PartnerImaOtvorenihStavaka",
			params: [$id]
	    });	
	}	
	
	function IzvodSSetAfterBrojRacuna(izvodS, novi, errorOverride){
		return $.dsDirectCallPost({
			method: "IzvodSSetAfterBrojRacuna",
			controller: "izvodS",
			params: [ novi ],
			data: [ izvodS ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}		
	
	function IzvodSKodKnjizenjaIzvodaSeUZatvoriRnUpisujeBrojUfe(izvodS, errorOverride){
		return $.dsDirectCallPost({
			method: "IzvodSKodKnjizenjaIzvodaSeUZatvoriRnUpisujeBrojUfe",
			controller: "izvodS",
			params: [],
			data: [ izvodS ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}	
	
	function IzvodSKodZatvaranjaProvjeriOJUBrojuRacuna(izvodS, errorOverride){
		return $.dsDirectCallPost({
			method: "IzvodSKodZatvaranjaProvjeriOJUBrojuRacuna",
			controller: "izvodS",
			params: [],
			data: [ izvodS ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}	
	
	function IzvodValidateMoguceKnjizenjeOdabranih(izvodArr){
		return $.dsDirectCall({
			method: "IzvodValidateMoguceKnjizenjeOdabranih",
			params: [izvodArr]
	    });	
	}	
			
	function IzvodProknjizi(izvodArr, dokum, brojDokumenta, datumDokumenta){
		return $.dsDirectCall({
			method: "IzvodProknjizi",
			params: [izvodArr, dokum, brojDokumenta, datumDokumenta]
	    });	
	}
	
	function IzvodProknjiziPost(izvodArr, dokum, brojDokumenta, datumDokumenta, errorOverride){
		
		
		json = {
			odabraniIzvodi: izvodArr,
			dokum: dokum,
			brojDokumenta: brojDokumenta,
			datumDokumenta: datumDokumenta
		}
		
		return $.dsDirectCallPostJSON({
			method: "proknjizi",
			controller: "izvod",
			data: [ json ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false); 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}
		});		
	}		
	
	function IzvodProknjiziUPozadini(izvodArr, dokum, brojDokumenta, datumDokumenta){
		return $.dsDirectCall({
			method: "IzvodProknjiziUPozadini",
			params: [izvodArr, dokum, brojDokumenta, datumDokumenta]
	    });	
	}		
	
	function GetIzvodSaldoDugujePotrazuje(id){
		return $.dsDirectCall({
			method: "GetIzvodSaldoDugujePotrazuje",
			params: [id]
	    });	
	}
	
	function RUgovorSListaPremaShemiURuGrupa(rugrupa, datum){
		return $.dsDirectCall({
			method: "gs/RUgovorSListaPremaShemiURuGrupa",
			params: [ rugrupa, datum ]
		});
	}
			
			
	function ProcitajIzvadak(PreuzmiIzvod, vrstaIzvoda, zapisUTbl, fileExt, errorOverride){
		return $.dsDirectCallPost({
			method: "PreuzmiIzvodProcitajIzvadak",
			controller: "preuzmiizvod",
			params: [vrstaIzvoda, zapisUTbl, fileExt],
			data: [ PreuzmiIzvod ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}		
			
	function PreuzmiIzvodDokumentPostoji(PreuzmiIzvod, vrstaIzvoda, zapisUTbl, errorOverride){
		return $.dsDirectCallPost({
			method: "PreuzmiIzvodDokumentPostoji",
			controller: "preuzmiizvod",
			params: [vrstaIzvoda, zapisUTbl],
			data: [ PreuzmiIzvod ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}		
	
	function PreuzmiIzvodDokumentVecProknjizen(PreuzmiIzvod, vrstaIzvoda, zapisUTbl, errorOverride){
		return $.dsDirectCallPost({
			method: "PreuzmiIzvodDokumentVecProknjizen",
			controller: "preuzmiizvod",
			params: [vrstaIzvoda, zapisUTbl],
			data: [ PreuzmiIzvod ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}							
			
	function PreuzmiIzvodPreuzmiIzvod(PreuzmiIzvod, vrstaIzvoda, zapisUTbl, fileExt, errorOverride){
		return $.dsDirectCallPost({
			method: "PreuzmiIzvodPreuzmiIzvod",
			controller: "preuzmiizvod",
			params: [vrstaIzvoda, zapisUTbl, fileExt],
			data: [ PreuzmiIzvod ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}	
	
	function GetUrediRedoslijedGkBrojStavke(id){
		return $.dsDirectCall({
			method: "GetUrediRedoslijedGkBrojStavke",
			params: [id]
	    });	
	}	
	
	function UrediRedoslijedGkBrojStavke(id){
		return $.dsDirectCall({
			method: "UrediRedoslijedGkBrojStavke",
			params: [id]
	    });	
	}					
	
	function GetKnjigaPonistiVezuSaSK(id){
		return $.dsDirectCall({
			method: "GetKnjigaPonistiVezuSaSK",
			params: [id]
	    });	
	}	
	
	function KnjigaPonistiVezuSaSK(id, uPozadini){
		return $.dsDirectCall({
			method: "KnjigaPonistiVezuSaSK",
			params: [id, uPozadini]
	    });	
	}		
		
	function KnjigaSaldoPartneraZaOvajDokument(id){
		return $.dsDirectCall({
			method: "KnjigaSaldoPartneraZaOvajDokument",
			params: [id]
	    });	
	}
	
	function KnjigaGetPartnerZaOvajDokument(godina, dokum, brojDokumenta, skBrojStavke){
		return $.dsDirectCall({
			method: "KnjigaGetPartnerZaOvajDokument",
			params: [godina, dokum, brojDokumenta, skBrojStavke]
	    });	
	}
	
	function KnjigaZakljucajDokument(id){
		return $.dsDirectCall({
			method: "KnjigaZakljucajDokument",
			params: [id]
	    });	
	}
	
	function KnjigaOtkljucajDokument(id){
		return $.dsDirectCall({
			method: "KnjigaOtkljucajDokument",
			params: [id]
	    });	
	}		
	
	function KnjigaGetDokumentZakljucanCaption(id){
		return $.dsDirectCall({
			method: "KnjigaGetDokumentZakljucanCaption",
			params: [id]
	    });	
	}	
	
	function GenPrometaSetRequiredAfterKontoPrometa(GenPrometa, errorOverride){
		return $.dsDirectCallPost({
			method: "GenPrometaSetRequiredAfterKontoPrometa",
			controller: "knjiga",
			params: [],
			data: [ GenPrometa ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}	
	
	function PredloziKontoDo(kontoOD){
		return $.dsDirectCall({
			method: "PredloziKontoDo",
			params: [kontoOD]
	    });	
	}	
	
	function GetRiznicaLabelCaption(riznica, riznicas, skraceno){
		return $.dsDirectCall({
			method: "gs/GetRiznicaLabelCaption",
			params: [ riznica, riznicas, skraceno ]
		});
	}
	
	
	function KnjigaIzrSaldoFilter(konto, kontoOd, kontoDo, valuta, pozicija, izvori, verzija){
		return $.dsDirectCall({
			method: "KnjigaIzrSaldoFilter",
			params: [konto, kontoOd, kontoDo, valuta, pozicija, izvori, verzija]
	    });	
	}
	
	function SaldaSetAfterPolje(novi, polje, salda){
		return $.dsDirectCall({
			method: "SaldaSetAfterPolje",
			params: [ novi, polje, salda ]
		});
	}	

	function SaldaSetAfterMTroska(novi, mtroska, organ){
		return $.dsDirectCall({
			method: "gs/SaldaSetAfterMTroska",
			params: [ novi, mtroska, organ ]
		});
	}	

	function SaldaSetAfterOrgan(novi, organ, mtroska){
		return $.dsDirectCall({
			method: "gs/SaldaSetAfterOrgan",
			params: [ novi, organ, mtroska ]
		});
	}	
	
	function SaldaImportXlsUPozadini(saldaimportxls){
		return $.dsDirectCallPost({
			method: "ImportSaldaXlsUPozadiniSubmit",
			controller: "Salda",
			params: [  ],
			data: [ saldaimportxls ]		
		});	
		
	}
	

	function IzvodSPrimjeniPravilo(izvodShema, izvodSArray){
		return $.dsDirectCall({
			method: "IzvodSPrimjeniPravilo",
			params: [ izvodShema, izvodSArray ]
		});
	}		

	function IzvodSSetAfterPolje(polje, izvodS, errorOverride){
        return $.dsDirectCallPost({
            method: "IzvodSSetAfterPolje",
            controller: "izvodS",
            params: [ polje ],
            data: [ izvodS ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	
	
	function IzvodSPredloziKnjizenje(izvod, izvodS, salOtvoreneData, errorOverride){	
        return $.dsDirectCallPost({
            method: "IzvodSPredloziKnjizenje",
            controller: "izvodS",
            params: [ izvod, izvodS ],
            data: [ salOtvoreneData ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }


	function ProrUtrProvjeriDupliMjesecniPlan(prorUtr, organ, pozGrupa1){
		return $.dsDirectCall({
			method: "ProrUtrProvjeriDupliMjesecniPlan",
			params: [prorUtr, organ, pozGrupa1]
	    });	
	}	

	function ProracunById(proracun){
		return $.dsDirectCall({
			method: "ProracunById",
			params: [proracun]
	    });
	}

	function IzvodSPoveziSViseFaktura(izvod, izvodS, lRacuni, lUplate, errorOverride){	
        return $.dsDirectCallPostJSON({
            method: "IzvodSPoveziSViseFaktura",
			controller: "IzvodS",			
            params: [ izvod, izvodS ],
			data: [lRacuni, lUplate],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function SalOtvoreneStaviUListuZatvorenihRacuna(salOtvoreneList, partnerId, predloziSaldoF7, glavarina, errorOverride){
		return $.dsDirectCallPostJSON({
			method: "SalOtvoreneStaviUListuZatvorenihRacuna",
			controller: "SalOtvorene",
			params: [ partnerId, predloziSaldoF7, glavarina ],
			data: [ salOtvoreneList ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }			
		});
	}		

	function SalOtvoreneZatvaranjeRacunaUplatomIliTemeljnicom(partner, organ, pozivZatvoriRacuneKaoPlacanje, lRacuni, lUplate, errorOverride){	
        return $.dsDirectCallPostJSON({
            method: "SalOtvoreneZatvaranjeRacunaUplatomIliTemeljnicom",
			controller: "SalOtvorene",			
            params: [ partner, organ, pozivZatvoriRacuneKaoPlacanje ],
			data: [lRacuni, lUplate],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	
	
	function ZatvoriTemGetNextBroj(zatvoriTem, errorOverride){
        return $.dsDirectCallPost({
            method: "ZatvoriTemGetNextBroj",
            controller: "SalOtvorene",
            data: [ zatvoriTem ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }		

	function ZatvoriTemValidateBrojDokumenta(zatvoriTem, errorOverride){
        return $.dsDirectCallPost({
            method: "ZatvoriTemValidateBrojDokumenta",
            controller: "SalOtvorene",
            data: [ zatvoriTem ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }		

	function SalOtvoreneOvrhe(prijenosIz){
		return $.dsDirectCall({
			method: "SalOtvoreneOvrhe",
			params: [ prijenosIz ]
	    });
	}

	function KnjigaPromBrDokGetNextBroj(knjiga, errorOverride){
        return $.dsDirectCallPost({
            method: "KnjigaPromBrDokGetNextBroj",
            controller: "Knjiga",
            data: [ knjiga ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }		

	function SaldaPromBrDokGetNextBroj(salda, errorOverride){
        return $.dsDirectCallPost({
            method: "SaldaPromBrDokGetNextBroj",
            controller: "Salda",
            data: [ salda ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }

	function AzurUtrosenoOtpustenoFakturiranoZaRUgovor(rUgovor){
		return $.dsDirectCall({
			method: "AzurUtrosenoOtpustenoFakturiranoZaRUgovor",
			params: [ rUgovor ]
	    });
	}

	function DokumentDatumDospjecaNeradniDan(datumDospijeca){
		return $.dsDirectCall({
			method: "gs/DokumentDatumDospjecaNeradniDan",
			params: [ datumDospijeca ]
		});
	}

	function KnjiziTecRazlikeSetAfterPolje(polje, knjiziTecRazlike, errorOverride){
        return $.dsDirectCallPost({
            method: "KnjiziTecRazlikeSetAfterPolje",
            controller: "Salda",
			params: [ polje ],
            data: [ knjiziTecRazlike ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function KnjiziTecRazlikeNextBrojDok(knjiziTecRazlike, errorOverride){
        return $.dsDirectCallPost({
            method: "KnjiziTecRazlikeNextBrojDok",
            controller: "Knjiga",
            data: [ knjiziTecRazlike ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }		

	function KnjiziTecRazlikeDBToGsVars(knjiziTecRazlike, errorOverride){
        return $.dsDirectCallPost({
            method: "KnjiziTecRazlikeDBToGsVars",
            controller: "Knjiga",
            data: [ knjiziTecRazlike ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });
    }         
	
   	function GenKnjigaRasSetAfterPolje(polje, obj, errorOverride){
		return $.dsDirectCallPost({
			method: "GenKnjigaRasSetAfterPolje",
			controller: "knjiga",	
			params: [ polje ],			
			data: [ obj ],					
			fail: function (error, textStatus, jqXHR, logicalError){
			    KUtils.busy(false); 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}
		});
	}
	
   	function GenKnjigaRasValidate(obj, errorOverride){
		return $.dsDirectCallPost({
			method: "GenKnjigaRasValidate",
			controller: "knjiga",	
			params: [ ],			
			data: [ obj ],					
			fail: function (error, textStatus, jqXHR, logicalError){
			    KUtils.busy(false); 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}
		});
	}			

	function GenProtuSetAfterPolje(polje, genProtu, errorOverride){
        return $.dsDirectCallPost({
            method: "GenProtuSetAfterPolje",
            controller: "Knjiga",
			params: [ polje ],
            data: [ genProtu ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	
    
	function KnjigaImportXlsUPozadini(knjigaimportxls){
		return $.dsDirectCallPost({
			method: "ImportKnjigaXlsUPozadiniSubmit",
			controller: "Knjiga",
			params: [  ],
			data: [ knjigaimportxls ]		
		});	
		
	}
    
    function PNabaveSKontrolePlanPror(brKontrole, pNabave){
		return $.dsDirectCall({
			method: "PNabaveSKontrolePlanPror",
			params: [ brKontrole, pNabave ]
		});
	}

	function GenProtuGetPitanja(genProtu, errorOverride){
        return $.dsDirectCallPost({
            method: "GenProtuGetPitanja",
            controller: "Knjiga",
            data: [ genProtu ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }

	function SaldaTrSetAfterPolje(polje, saldaTr, novi, errorOverride){
		return $.dsDirectCallPost({
			method: "SaldaTrSetAfterPolje",
			controller: "saldaTr",	
			params: [ polje, novi ],			
			data: [ saldaTr ],					
			fail: function (error, textStatus, jqXHR, logicalError){
			    KUtils.busy(false); 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}
		});
	}
	
	function GenProtuDBToGsVars(knjiziTecRazlike, errorOverride){
        return $.dsDirectCallPost({
            method: "GenProtuDBToGsVars",
            controller: "Knjiga",
            data: [ knjiziTecRazlike ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });
    } 	
    
    function GetOpzStatSFields() {
        return $.dsDirectCall({ 
			method: "GetOpzStatSFields"
        });
    }
    
    function GetOpzStatPitanjaZaBrisanje(opzStat){
		return $.dsDirectCall({
			method: "GetOpzStatPitanjaZaBrisanje",
			params: [ opzStat ]
		});
	}
	
    function GetPitanjaZaObrisiVezuPremaSKIzStavaka(opzStat){
		return $.dsDirectCall({
			method: "GetPitanjaZaObrisiVezuPremaSKIzStavaka",
			params: [ opzStat ]
		});
	}
	
    function GetOpzStatSPitanjaZaBrisanje(opzStatS){
		return $.dsDirectCall({
			method: "GetOpzStatSPitanjaZaBrisanje",
			params: [ opzStatS ]
		});
	}
	
	function OpzStatAzuriraj(opzStat, radnja, nazivRadnje){
		return $.dsDirectCall({
			method: "OpzStatAzuriraj",
			params: [ opzStat, radnja, nazivRadnje ]
		});
	}
	
	function OpzStatSObrisi(opzStatS){
		return $.dsDirectCall({
			method: "OpzStatSObrisi",
			params: [ opzStatS ]
		});
	}
	
	function ObrisiSveStavkeZaKonto(opzStatS){
		return $.dsDirectCall({
			method: "ObrisiSveStavkeZaKonto",
			params: [ opzStatS ]
		});
	}
	
	function GetPitanjaZaBrisanjeSvihStavakaZaKonto(opzStatS){
		return $.dsDirectCall({
			method: "GetPitanjaZaBrisanjeSvihStavakaZaKonto",
			params: [ opzStatS ]
		});
	}
	
    function GetPitanjaZaFormiranjeOpzStat(opzStat){
		return $.dsDirectCall({
			method: "GetPitanjaZaFormiranjeOpzStat",
			params: [ opzStat ]
		});
	}
	
    function OpzStatSSetAfterPartner(partner, naDan){
		return $.dsDirectCall({
			method: "OpzStatSSetAfterPartner",
			params: [ partner, naDan ]
		});
	}
	
    function KontoNadredjenaKontaPostoje(konto, godina){
		return $.dsDirectCall({
			method: "gs/KontoNadredjenaKontaPostoje",
			params: [ konto, godina ]
		});
	}
	
    function GetVanbilancnoFields(rugovor, salda){
		return $.dsDirectCall({
			method: "GetVanbilancnoFields",
			params: [ rugovor, salda ]
		});
	}
	
	function KnjigaBrisanjeViseStavaka(dataCB){
		return $.dsDirectCall({
			method: "KnjigaBrisanjeViseStavaka",
			params: [ dataCB ]
		});
	}
	
	function NaplacenGsObrisi(id){
		return $.dsDirectCall({
			method: "NaplacenGsObrisi",
			params: [ id ]
		});
	}
	
	function NaplacenGsObrisiList(list){
		return $.dsDirectCall({
			method: "NaplacenGsObrisiList",
			params: [ list ]
		});
	}

	function NaplacenGsGeneriraj(datumOd, datumDo){
		return $.dsDirectCall({
			method: "NaplacenGsGeneriraj",
			params: [ datumOd, datumDo ]
		});
	}
	
	function NaplacenGsIzvjestavanje(uPozadini){
		return $.dsDirectCall({
			method: "NaplacenGsIzvjestavanje",
			params: [ uPozadini ]
		});
	}
	
	function NaplacenGsOznaciDaJeRucnoIzvijesteno(id){
		return $.dsDirectCall({
			method: "NaplacenGsOznaciDaJeRucnoIzvijesteno",
			params: [ id ]
		});
	}

	function ProvjeriProtukontoTrebaBitiZadan(godina, konto){
		return $.dsDirectCall({
			method: "ProvjeriProtukontoTrebaBitiZadan",
			params: [godina, konto]
	    });	
	}

	function PartnerKorSrIzOibIzBrojRacuna(brojRacuna){
		return $.dsDirectCall({
			method: "PartnerKorSrIzOibIzBrojRacuna",
			params: [brojRacuna]
	    });	
	}
	
	function IRazno2AfterVrstaDok(dokum){
		return $.dsDirectCall({
			method: "IRazno2AfterVrstaDok",
			params: [dokum]
	    });	
	}
	

} (konto.gs.api = {}));